<template>
    <div>
        <h5>Edicion de Contenido</h5>
        <hr />
        <div v-on="obtenerInicializarFormulario ?this.inicializarFormulario():this.noHacerNada()" >
            <div> 
                <!-- <div class="contenedor-puntero">
                    <h6>[Agregando contenido en: {{obtenerPunterosParaContenido.paginaWebSeleccionada + '/' + obtenerPunterosParaContenido.rutaSecciones}}]</h6>
                
                {{obtenerCamposRequeridosEnFormulario.TextoDelVinculo}}
                </div> -->
            <!--    <div class="contenedor-cambio-seccion">
                    <div>
                        <button type="button" class="btn btn-primary" @click="cambioDeSeccion"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar de Sección</button>
                    </div> 
                </div>   -->
                <!-- <hr /> -->
            </div>

          


            <div v-if="obtenerCamposRequeridosEnFormulario.AbrirEnVisor" class="btn-group btn-group-toggle linea-horizontal caja-campos" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[!visualizarEnVisor?'active':'' ]" @click="visualizarEnVisor=false">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Descargar Directamente
                        </label>
                        <label class="btn btn-secondary" :class="[visualizarEnVisor?'active':'' ]" v-tooltip:top="textoVisualizarEnVisor" @click="visualizarEnVisor=true">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >Visualizar en Visor
                        </label>
                     <hr/>
            </div>


            <!-- <div v-if="obtenerCamposRequeridosEnFormulario.ApareceEnComunicados" class="btn-group btn-group-toggle linea-horizontal caja-campos" data-toggle="buttons">       
                        <label class="btn btn-secondary" :class="!esComunicado?'active':'' " @click="esComunicado=false">
                            <input type="radio" name="options" id="noEsComunicado" autocomplete="off"  checked>No es Comunicado
                        </label>
                        <label class="btn btn-secondary" :class="esComunicado?'active':'' " v-tooltip:top="textoEsComunicado" @click="esComunicado=true">
                            <input type="radio" name="options" id="esComunicado" autocomplete="off" >Es Comunicado
                        </label>                
                     <hr/>
                    </div> -->
                    
                     <div v-if="obtenerCamposRequeridosEnFormulario.SeleccionaImagenOTexto" class="btn-group btn-group-toggle linea-horizontal caja-campos" data-toggle="buttons">
                        <label :class="esImagen?'active':''" class="btn btn-secondary" @click="esImagen=true, esTexto=false">
                            <input type="radio" name="options" id="esImagen" autocomplete="off"  checked>Es Imagen
                        </label>
                        <label :class="!esImagen?'active':''" class="btn btn-secondary" v-tooltip:top="textoEsImagen" @click="esImagen=false, esTexto=true,limpiarImagen()">
                            <input type="radio" name="options" id="esTexto" autocomplete="off" >Es Texto
                        </label>
                    <hr>
                    </div> 
                    

                    <div v-if="obtenerCamposRequeridosEnFormulario.TituloCarruselTexto && esTexto" class="caja-campos">
                      <h6>Ingrese un título</h6>
                    <input v-model="tituloCarruselYTexto" type="text" id="texto_vinculo_contenido" :class="'form-control'" placeholder="Ingrese titulo de la descripcion del textoo" />
                   </div>
                   <div v-if="obtenerCamposRequeridosEnFormulario.TextoDelContenidoCarrusel && esTexto" class="caja-campos">
                    <h6>Ingrese una descripción</h6>
                        <textarea  v-model="textoDelContenidoCarrusel" :class="[!this.campoEsValidoFormulario(textoDelContenidoCarrusel) && mostrarErroresInput && !obtenerCambiarFormulario ? 'form-control border border-danger': 'form-control']" type="text" rows="5" id="descripcion_contenido"  placeholder="Ingrese una descripciónn" />
                    <hr />
                   </div>

            <div v-if="obtenerCamposRequeridosEnFormulario.TextoDelContenidoTitulo" class="caja-campos">
                <h6>Ingrese un título</h6>
                <input v-model="titulo" type="text" id="titulo_contenido" :class="[!this.campoEsValidoFormulario(titulo) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el título" />
                <hr />
            </div>

            <div v-if="obtenerCamposRequeridosEnFormulario.RutaVinculo" class="caja-campos">
                <h6>Ingrese la ruta del Recurso</h6>
                <input v-model="rutaVinculo" type="text" id="ruta_recurso" :class="[!this.campoEsValidoFormulario(rutaVinculo) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="Ingrese ruta del recurso" />
                <hr />
            </div>

              <div v-if="obtenerCamposRequeridosEnFormulario.ArchivosTituloDelDato" >
                     <div v-if="obtenerCamposRequeridosEnFormulario.EsLink" class="btn-group btn-group-toggle linea-horizontal caja-campos" data-toggle="buttons">
                        <label class="btn btn-secondary" @click="EsLink=false" :class="!EsLink?'active':''">
                            <input type="radio" name="options" id="esLink" autocomplete="off"  checked>No es Link
                        </label>
                        <label class="btn btn-secondary" v-tooltip:top="textoEsLink" @click="EsLink=true" :class="EsLink?'active':''">
                            <input type="radio" name="options" id="noEsLink" autocomplete="off" >Es Link
                        </label>           
                    </div>
             <div class="caja-campos">
                <h6>Ingrese tipo de contacto</h6>
                <input v-model="tituloContacto" type="text" id="titulo_contacto" :class="[!this.campoEsValidoFormulario(nombrePresidente) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="Ingrese tipo de contacto" />               
            </div> 
             <div class="caja-campos">
                <h6 v-if="EsLink">Ingrese Link</h6>
                <h6 v-if="!EsLink">Ingrese descripcion del contacto</h6>
                <input v-model="descripcionContacto" type="text" id="descripcion_contacto" :class="[!this.campoEsValidoFormulario(nombrePresidente) && mostrarErroresInput && !obtenerCambiarFormulario? 'form-control border border-danger': 'form-control']" placeholder="Ingrese descripcion del contacto" />
                <hr />
            </div>

             <div  class="elementos-archivos-contenido text-right">
                        <button type="button" class="btn btn-primary" @click="agregarDatosParaContacto"><i class="fas fa-file-upload"></i>&nbsp;&nbsp;Agregar&nbsp;</button>
             </div> 
        
        </div>

        <div class="elementos-archivos-contenido" v-if="listaDeArchivos.length > 0 && obtenerCamposRequeridosEnFormulario.ArchivosTextoDeDescripcion">
                    <div style="display: flex;">
                        <h6>Numero de contactos agregados: {{listaDeArchivos.length}}</h6>
                        <div v-if="listaDeArchivos.length > 1" class="opciones-vaciar-listaDeArchivos">
                            <div class="linea-vertical"></div>
                            <span style="margin-left: 6px;"><i class="fas fa-folder-minus" style="cursor: pointer; font-size: 1.5em;" @click="informarVaciarListaDeArchivosAgregados" v-tooltip:top="'Eliminar todos los archivos agregados'"></i></span>
                        </div>
                    </div>
                    <div :class="[listaDeArchivos.length > 100 ? 'contenedor-listado-archivos' :'contenedor-listado-archivos']">
                        <table class="table table-dark" style="width: 100%; heigth: 100%;">
                        <thead>
                            <tr>
                            <th style="width: 40%" scope="col">Tipo Contacto</th>
                            <th style="width: 30%" scope="col">Texto Descripcion</th>
                          
                            <th style="width: 10%" scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(archivo,index) in listaDeArchivos" :key="'Archivo' + index" >
                                <td class="fuente-tabla" style="width: 40%;">{{archivo.Titulo}}</td>
                                <td v-if="archivo.TextoDescripcion!='EsLink'" class="fuente-tabla" style="width: 30%;">{{archivo.TextoDescripcion}}</td>
                                <td v-if="archivo.TextoDescripcion=='EsLink'" class="fuente-tabla" style="width: 30%">{{archivo.RutaDelArchivo}}</td>
                                <td class="text-center mx-auto fuente-tabla" style="width: 10%;"><i :id="archivo.id" class="fas fa-trash-alt elemento-eliminar-archivo" @click="informarEliminarDatoDeLista($event)" v-tooltip:right="'Eliminar archivo de la lista'" style="font-size: 1.5em;"></i></td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
</div>
            
                    

<div v-if="obtenerCamposRequeridosEnFormulario.Columnas" class="caja-campos">   
<div v-for="(columna,index) in obtenerTituloDeSeccion.titulo.split('|')" :key="index" >
<div v-if="index!=(obtenerTituloDeSeccion.titulo.split('|').length - mostrarUltimaColumna)">
<h6>Ingrese un texto para {{columna}}</h6>
<input v-model="numeroDeColumnas[index]"   type="text" :id="'texto_vinculo_contenido'+index" :class="[mostrarErroresInput && !obtenerCambiarFormulario ? 'form-control border border-danger': 'form-control']"  placeholder="Ingrese texto" />
 </div>
</div>                    
</div>

                <div v-if="obtenerCamposRequeridosEnFormulario.TituloCarrusel" class="caja-campos">
                    <h6>Ingrese un titulo para la imagen</h6>
                    <input v-model="tituloCarrusel" type="text" id="texto_vinculo_contenido" :class="[!this.campoEsValidoFormulario(tituloCarrusel) && mostrarErroresInput && !obtenerCambiarFormulario ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese titulo de la descripcion del video" />            
                </div>

                <div v-if="obtenerCamposRequeridosEnFormulario.TextoDelVinculoVideo" class="caja-campos">
                    <h6>Ingrese titulo de la descripcion del video</h6>
                    <input v-model="textoVinculo" type="text" id="texto_vinculo_contenido" :class="[!this.campoEsValidoFormulario(textoVinculo) && mostrarErroresInput && !obtenerCambiarFormulario ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese titulo de la descripcion del video" />
                    <hr />
                </div>

                  <div v-if="obtenerCamposRequeridosEnFormulario.RutaDelVideo" class="btn-group btn-group-toggle linea-horizontal caja-campos" data-toggle="buttons">
                        <label class="btn btn-secondary" @click="subirVideo=false" :class="!subirVideo?'active':''">
                            <input type="radio" name="options" id="esLink" autocomplete="off"  checked>Video Por Liga
                        </label>
                        <label class="btn btn-secondary" v-tooltip:top="textoEsLink" @click="subirVideo=true" :class="subirVideo?'active':''">
                            <input type="radio" name="options" id="noEsLink" autocomplete="off" >Subir Video
                        </label>                   
             </div>

 <button v-if="subirVideo" v-on:click="mostrarVideoActual = !mostrarVideoActual" class="btn btn-success" title="Ver video"><i class="fas fa-eye"></i></button>
 <div  v-if="mostrarVideoActual && subirVideo && contenido.RutaDeArchivo!=null && contenido.RutaDeArchivo!=''  ">
 <video width="800em" height="400vh" :src="contenido.RutaDeArchivo" controls load="false"></video>
 </div>
 <div v-if="subirVideo" :class="[this.validarOpcionToggleArchivo() ? 'elementos-archivos-contenido' : '']">
                    <h6>Seleccione el video</h6>
                    <input type="file" id="descarga_video" ref="" :class="[!this.campoEsValidoFormulario(this.VIDEO_CONTENIDO) && mostrarErroresInput && !obtenerCambiarFormulario &&  listaDeArchivos.length == 0? 'form-control border border-danger': 'form-control']" v-on:change="subirArchivoVideo($event)" accept=".MP4,.AVI,.WMV" />
                </div>
            <div v-if="!subirVideo && obtenerCamposRequeridosEnFormulario.RutaDelVideo">
                <h6>Ingrese la ruta del Video</h6>
                <input v-model="rutaVideo" type="text" id="texto_vinculo_contenido" :class="[!this.campoEsValidoFormulario(textoVinculo) && mostrarErroresInput && !obtenerCambiarFormulario ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese la ruta del Video" />
                <hr />
            </div>
             <div v-if="obtenerCamposRequeridosEnFormulario.RutaDelVideo">
                <h6>Titulo del Video</h6>
                <input v-model="tituloVideo" type="text" id="titulo_video" class="form-control" placeholder="Ingrese el titulo para el Video" />
                <hr />
            </div>   


            <!-- <div v-if="obtenerCamposRequeridosEnFormulario.TituloComunicado && esComunicado">
                <h6>Ingrese Titulo Para Comunicado</h6>
                <input v-model="tituloComunicado" type="text" id="titulo_comunicado" :class="[!this.campoEsValidoFormulario(tituloComunicado) && mostrarErroresInput && !obtenerCambiarFormulario ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el titulo para el comunicado" />
            </div>  -->


            <div   v-if="obtenerCamposRequeridosEnFormulario.RutaDeImagen && esImagen ">
               <div class="form-inline"><h6>Imagen Actual</h6>&nbsp;&nbsp;
              <a :href="descargarArchivo(imagenActual)" class="btn btn-success"><i class="fas fa-download"></i></a><br>
              &nbsp;&nbsp; 
               <button v-on:click="mostrarImagenActual = !mostrarImagenActual" class="btn btn-success"><i class="fas fa-eye"></i></button>
               </div>
               <img v-if="mostrarImagenActual" class="imagen-actual" :src="imagenActual">
               <div class="caja-campos">
                <h6>Seleccione la imagen del contenido</h6>
                <input type="file" id="imagen_contenido" ref="" :class="[!this.campoEsValidoFormulario(this.IMAGEN_CONTENIDO) && mostrarErroresInput && !obtenerCambiarFormulario  ? 'form-control border border-danger': 'form-control']" v-on:change="subirImagen($event)" accept=".JPEG,.JPG,.PNG" />
                <hr />
                </div>
            </div>
            <div v-if="obtenerCamposRequeridosEnFormulario.TextoDelContenido" class="caja-campos">
                 <h6>Ingrese una descripción</h6>        
                <textarea  v-model="textoDelContenido" :class="[!this.campoEsValidoFormulario(textoDelContenido) && mostrarErroresInput && !obtenerCambiarFormulario && obtenerCamposRequeridosEnFormulario.TextoDelContenidoRequerido ? 'form-control border border-danger': 'form-control']" type="text" rows="12" id="descripcion_contenido"  placeholder="Ingrese una descripción" />
                <hr />
            </div>

                <div v-if="obtenerCamposRequeridosEnFormulario.ArchivoAdicional" class="btn-group btn-group-toggle linea-horizontal caja-campos" data-toggle="buttons">
                        <label class="btn btn-secondary"  :class="[!tieneArchivoAdicional?'active':'' ]" @click="tieneArchivoAdicional=false">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Sin Archivo
                        </label>
                        <label class="btn btn-secondary"  :class="[tieneArchivoAdicional?'active':'' ]" v-tooltip:top="textoAgregarArchivo" @click="tieneArchivoAdicional=true">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >Agregar Archivo
                        </label>

                    
                     <hr/>
          
            </div>

              <div v-if="obtenerCamposRequeridosEnFormulario.AbrirEnVisorAdicional && tieneArchivoAdicional" class="btn-group btn-group-toggle linea-horizontal caja-campos" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[!visualizarEnVisorAdicional?'active':'' ]" @click="visualizarEnVisorAdicional=false">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Descargar Directamente
                        </label>
                        <label class="btn btn-secondary" :class="[visualizarEnVisorAdicional?'active':'' ]" @click="visualizarEnVisorAdicional=true">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >Visualizar en Visor
                        </label>
            </div>

             <div v-if="obtenerCamposRequeridosEnFormulario.TextoDelVinculo ||tieneArchivoAdicional" class="caja-campos">
                     <h6>Ingrese texto del vínculo</h6>
                     <input v-model="textoVinculoArchivo" type="text" id="texto_vinculo_archivo" :class="[!validaVinculoArchivoAdicional? 'form-control border border-danger': 'form-control']" placeholder="Ingrese texto del vínculo" />
                </div>


<div v-if="obtenerCamposRequeridosEnFormulario.TablaPorContenido" class="caja-campos">
 <hr>
 <h3>Agregar Columnas</h3>
 <input type="text" v-model="NombreColumna" class="form-control" placeholder="Ingrese descripcion del contacto" ><br>
 <button v-if="nuevasFilas.length<=0" class="btn btn-info" v-on:click="agregarColumna">Agregar Columna</button>

<table class="table table-striped table-hover table-bordered mt-4">
    <thead class="thead-light">
<tr><th>Columna</th><th style="width:8px">Eliminar</th></tr>
    </thead>
    <tbody>
<tr v-for="(columna,index) in columnasTablaContenido" :key="index"><th>{{columna}}</th><th><button class="btn btn-danger" v-on:click="eliminarColumna(columna)"><i class="fa fa-trash"></i></button></th></tr>
    </tbody>
</table>

<hr>
<h2>Agregar Filas</h2>
<div v-for="(inputcampo,index) in columnasTablaContenido" :key="index">
<h6>Ingrese un texto para {{inputcampo}}</h6>
<input type="text" v-model="listaFilas[index]" class="form-control" placeholder="Ingrese descripcion del contacto" ><br>
</div>
<div v-if="listaFilas.length>0 && columnasTablaContenido.length>0">
     <h6>Seleccione el archivo de descarga</h6>
     <input type="file" id="descarga_multiple" ref="" :class="[!this.campoEsValidoFormulario(this.ARCHIVO_DESCARGA) && mostrarErroresInput && !obtenerCambiarFormulario &&  listaDeArchivos.length == 0? 'form-control border border-danger': 'form-control']" v-on:change="subirArchivoDescarga($event)" accept=".PDF,.XLSX,.XLSB,.ZIP" />
</div>
<br>
 <button class="btn btn-info" v-on:click="agregarFila()">Agregar Fila</button>
<table class="table table-striped table-hover table-bordered mt-4">
    <thead class="thead-light">
<tr><th v-for="(col,index) in columnasTablaContenido" :key="index">{{col}}</th> <th style="width:8px">Eliminar</th></tr>
    </thead>
    <tbody>
<tr v-for="(nuevaFila,index) in nuevasFilas" :key="index"><th  v-for="(aux,index2) in nuevaFila.split('|')" :key="index2" v-if="index2!=0">{{aux}}</th>
<th> <button class="btn btn-danger" v-on:click="eliminarFila(index)"><i class="fa fa-trash"></i></button></th></tr> 
    </tbody>
</table>
</div>
         


<div v-if="vinculoParaArchivo==false && obtenerCamposRequeridosEnFormulario.RutaDelArchivo == true ||tieneArchivoAdicional" class="btn-group btn-group-toggle caja-campos" data-toggle="buttons">
                     <label :class="[descargaArchivoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="descargaArchivoRadio=true, vinculoArchivoRadio=false">
                        <input type="radio" name="options" id="radioArchivoDeDescarga" autocomplete="off"  checked>Archivo de descarga
                    </label>
                    <label :class="[vinculoArchivoRadio ? 'btn btn-secondary active' : 'btn btn-secondary']" @click="vinculoArchivoRadio=true, descargaArchivoRadio=false,limpiarArchivo()">
                        <input type="radio" name="options" id="radioLinkAOtraPagina" autocomplete="off" >Vínculo del archivo
                    </label>
                </div>
                <div class="caja-campos" v-if="vinculoRadio">
                    <h6>Ingrese el vínculo a otra página (URL)</h6>
                    <input v-model="vinculo" type="text" id="vinculo_contenido" :class="[!this.campoEsValidoFormulario(vinculo) && mostrarErroresInput && !obtenerCambiarFormulario &&  listaDeArchivos.length == 0 ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el vínculo" />
                </div>
                <div v-if="descargaArchivoRadio==true && vinculoParaArchivo==false &&(obtenerCamposRequeridosEnFormulario.RutaDelArchivo||tieneArchivoAdicional)" :class="[this.validarOpcionToggleArchivo() ? 'caja-campos' : '']">
            <div v-if="!tieneArchivoAdicional && descargaArchivoRadio && vinculoParaArchivo==false &&obtenerCamposRequeridosEnFormulario.RutaDelArchivo" class="form-inline"><h6>Archivo Actual</h6>&nbsp;&nbsp;
              <a :href="descargarArchivo(contenido.RutaDeArchivo)" class="btn btn-success"><i class="fas fa-download"></i></a><br>
              &nbsp;&nbsp; 
               <button v-on:click="AbreElVisor(contenido.RutaDeArchivo)" class="btn btn-success"><i class="fas fa-eye"></i></button>
               </div> 
            
             <div v-if="tieneArchivoAdicional && contenido.ArchivoAdicional != null" class="form-inline"><h6>Archivo Actual</h6>&nbsp;&nbsp;
              <a :href="descargarArchivo(contenido.ArchivoAdicional)" class="btn btn-success"><i class="fas fa-download"></i></a><br>
              &nbsp;&nbsp; 
               <button v-on:click="AbreElVisor(contenido.ArchivoAdicional)" class="btn btn-success"><i class="fas fa-eye"></i></button>
               </div> 

                <div>    
                <h6>Seleccione el archivo de descarga</h6>
                    <input type="file" id="descarga_contenido" ref="" :class="[!this.validaArchivoAdicional && mostrarErroresInput && !obtenerCambiarFormulario &&  listaDeArchivos.length == 0? 'form-control border border-danger': 'form-control']" v-on:change="subirArchivoDescarga($event)" accept=".PDF,.XLSX,.XLSB,.ZIP" />
               </div>
               
                </div>
                 <div v-if="vinculoArchivoRadio" class="caja-campos">
                    <h6>Ingrese el vínculo(URL)</h6>
                    <input v-model="vinculo" type="text" id="vinculo_contenido" :class="[!this.campoEsValidoFormulario(vinculo) && mostrarErroresInput && !obtenerCambiarFormulario &&  listaDeArchivos.length == 0 ? 'form-control border border-danger': 'form-control']" placeholder="Ingrese el vínculo" />
                </div>

          <!-- </div>  -->
                                            
        </div>

            <div v-if="obtenerCamposRequeridosEnFormulario.FechaPublicacion">
                <h6 >Ingrese fecha de publicación</h6>
                <div style="display: flex;">
                    <div style="display: flex; align-items: center;">
                        <h6 v-if="urgenteRadio" style="margin-right: 5px;">Inicio </h6>
                        <datepicker :key="'dtPkInicio'" 
                                    :format="DatePickerFormato"  
                                    :highlighted="highlighted_DtPkInicio"
                                    :disabled-dates="disabledDates_DtPkInicio" 
                                    v-model="fechaDatePickerInicio"
                                    @selected="seleccionDeFechaDtPkInicio"  
                                    :value="this.fechaDefaultDtPkInicio" 
                                    :bootstrap-styling="true"
                                    :calendar-button="true"
                                    calendar-button-icon="far fa-calendar-alt" 
                                    name="fecha" 
                                    :language="languaje"></datepicker>
                    </div>
                    <div v-if="urgenteRadio" style="display: flex; align-items: center;">
                            <h6 style="margin-right: 5px;">Fin </h6>
                            <datepicker :key="'dtPkFin'" 
                                        :format="DatePickerFormato"  
                                        :highlighted="highlighted_DtPkFin"
                                        :disabled-dates="disabledDates_DtPkFin" 
                                        v-model="fechaDatePickerfinal"
                                        @selected="seleccionDeFechaDtPkFin"  
                                        :value="this.fechaDefaultDtPkFinal" 
                                        :bootstrap-styling="true"
                                        :calendar-button="true"
                                        calendar-button-icon="far fa-calendar-alt"  
                                        :class="{'texto-negro': true}" name="fecha" 
                                        :language="languaje"></datepicker>
                    </div>
                </div>
                <hr />
            </div>  
            
            <div>
                <div>                  
                </div>
            </div>
            <div class="text-right">
                <div>
                    <button type="button" class="btn btn-primary" @click="agregarContenido"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                   <button type="button" class="btn btn-primary" @click="cancelarEdicion"><i class="fas fa-window-close"></i>&nbsp;&nbsp;Cancelar</button>

                </div>
                
            </div>    
        </div>
   
</template>
<script>

import api from '@/../static/js/api'
import axios from 'axios'
import comun from "@/../static/js/comun"
import moment from 'moment';
import enumeraciones from '@/../static/js/enumeraciones'
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import C006Submenus from '../../Catalogos/C006Submenus.vue'
import Datepicker from 'vuejs-datepicker';
import CSelectGenerico from '@/components/SICPO/Comun/CSelectGenerico.vue'
import CListaDeImagenes from '../../Comun/CListaDeImagenes.vue'

export default {
     props:{
         contenido:Object
            },
    
    directives: {
        tooltipF
    },
//declaracion de variables 
    data() {
        return {
            enumeraciones_sicpo,
            tieneArchivoAdicional:false,
            mostrarVideoActual:false,
            tituloVideo:null,
            subirVideo:false,
            mostrarImagenActual:false,
            idDeContenidoMicrositio:0,
           imagenActual:null,
           archivoActual:null,
           mostrarUltimaColumna:0,
           formatoId:null,
            columnasTablaContenido:[],
            nuevasFilas:[],
            NombreColumna:null,
             LISTA_ARCHIVOS:[],
             listaFilas:[],
            fechaDatePickerInicio: null,
            fechaDatePickerfinal: new Date(),
            fechaSeleccionada: 0,
            fechaDefaultDtPkInicio: new Date(),
            fechaDefaultDtPkFinal: new Date(),
            DatePickerFormato: 'yyyy-MM-dd',
            zonaHoraria:'T12:00:00Z',
            languaje:{
                language: 'es',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                monthsAbbr: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                days: ['D','L', 'M', 'M', 'J', 'V', 'S'],
                rtl: false,
                ymd: 'yyyy-MM-dd',
                yearSuffix: ''
            },
            highlighted_DtPkInicio: {
                customPredictor: (dia) => {
                    let diasDeMes = null; // this.obtenerFecha(dia);
                   // let fechaFin = this.obtenerFecha(this.fechaDatePickerfinal);            
                    let fechaInicio =null;
                     if(this.fechaDatePickerInicio!=null) fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);                
                    if(this.informativoRadio) {
                        if(diasDeMes == fechaInicio) {
                            return true
                        }
                    }
                    
                    else if(this.urgenteRadio) {
                        if(diasDeMes >= fechaInicio && diasDeMes <= fechaFin) {
                             return true
                        }
                    }
                },
                includeDisabled: false
            },
            highlighted_DtPkFin: { 
                customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                 //   let fechaFin = this.obtenerFecha(this.fechaDatePickerfinal);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(diasDeMes >= fechaInicio && diasDeMes <= fechaFin) {
                        return true
                    }
                },
                includeDisabled: false
            },
            disabledDates_DtPkInicio: {
                 customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaActual = this.obtenerFecha(new Date());
                    if(diasDeMes < fechaActual)
                        return true
                }
            },
            disabledDates_DtPkFin: {
                 customPredictor: (dia) => {
                    let diasDeMes = this.obtenerFecha(dia);
                    let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
                    if(diasDeMes < fechaInicio){
                        return true
                    }
                }
            },
            enumeraciones,
            textoDelContenido: null,
            vinculoParaArchivo:false,
            IMAGEN_CONTENIDO: null,
            ARCHIVO_DESCARGA: null,
            VIDEO_CONTENIDO:null,
            mostrarSubidorDeArchivos: false,
            esImagen:true,
            esTexto:false,
            esComunicado:false,
            visualizarEnVisor:false,
            EsLink:false,
            tituloComunicado:null,
            tituloCarruselYTexto:null,
            textoDelContenidoCarrusel:null,
            tituloContacto:null,
            descripcionContacto:null,
            numeroDeColumnas:[],
            rutaVinculo:null,
            fechaDePublicacion: '',
            fechaDePublicacionFin: '',
            titulo: '',
            tituloCarrusel:null,
            textoVinculo: null,
            textoVinculoArchivo: null,
            textoVinculoPrincipal: null,
            rutaVideo:null,          
            contenidoConListaDeArchivos:false,
            vinculo: null,
            tituloArchivo: null,
            nombrePresidente: null,
            rangoPresidente: null,
            textoMensajeCampoFaltante:'',
            mostrarErroresInput: false,
            existePerdidaDeCambios: false,
            descargaRadio: false,
            vinculoRadio: false,
            textoBotonAgregaraAoV: 'Archivo',
            descargaArchivoRadio: true,
            vinculoArchivoRadio: false,
            vinculoArchivo: null,
            urgenteRadio: false,
            informativoRadio: false,
            sobreescribirArchivo: false,
            listaDeArchivos: [],
            listaDeArchivosBit:new Object(),
            contadorArchivos: 0,
            opcionVaciarListaArchivos: false,
            disposicionEspecial: false,
            esPin: false,
            textoTituloSubmenu: null,
            textoEsComunicado: 'Si esta opción es seleccionada este archivo se mostrará en la página principal del Micrositio con la imagen seleccionada',
            textoVisualizarEnVisor: 'Si esta opción es seleccionada este archivo se podra visualizar antes de poder descargar',
            textoEsImagen:'Si esta opción es seleccionada tendra que agregar una imagen para el carrusel',
            textoEsLink:'Si esta opción es seleccionada podra ingresar un link a una página exterior',
            textoAgregarArchivo:'Si esta ópcion es seleccionada podra agregar un archivo para ser descargado desde el carrusel',
            imagenDeObligacion: null,
            SERVIDOR_LOCAL:'//themisfs/',
            validaArchivoAdicional:true,
            validaVinculoArchivoAdicional:true,
            visualizarEnVisorAdicional:false
        }
    },
    components: {
        C006Submenus,
        Datepicker,
        CSelectGenerico,
        CListaDeImagenes
    },
    methods: {
AbreElVisor: function(vinculo) {
            this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,this.SERVIDOR_LOCAL));
      },
descargarArchivo: function(vinculo) {
  var ejecucion=null;
  if(vinculo != null){
    var rutaArchivo =vinculo.replace(enumeraciones_sicpo.Recursos.IpAccesoServidorArchivos,this.SERVIDOR_LOCAL);
    ejecucion =api.conexion+api.Comun.funcion.DescargarArchivo+'?'+'rutaDelArchivo='+rutaArchivo;
  }
 return ejecucion;
 },


subirArchivoListaDescarga:function(index){
    try{
        this.LISTA_ARCHIVOS.push({index:index-1,archivo:this.ARCHIVO_DESCARGA });
        this.ARCHIVO_DESCARGA = null;
        $("#descarga_multiple").val('');
        }catch(error){
        comun.mensajeDeAlerta(error);
        }
 },

agregarFila:function(){
            // console.log("filas::",this.listaFilas)
        if(this.ARCHIVO_DESCARGA!=null){
            var fila = "-1|";
            console.log("listas::: ", this.listaFilas);
            if(this.listaFilas.length < this.columnasTablaContenido.length){
                comun.mensajeDeAlerta('Favor de llenar todos los campos de la fila', null, null);
                  throw 'Error: campo de fila no valido';
            }

            this.listaFilas.forEach(element => {
                if(element==null || element==""){
                     comun.mensajeDeAlerta('Favor de llenar todos los campos de la fila', null, null);
                  throw 'Error: campo de fila no valido';
                }
                else fila = fila+element+"|";  
            });
            fila = fila.slice(0,-1);        
            this.nuevasFilas.push(fila);
            this.subirArchivoListaDescarga(this.nuevasFilas.length);
            
            var i = 0;
            for(i=0;i<this.listaFilas.length;i++){
                this.listaFilas[i]=null;
            }
        }else
         comun.mensajeDeAlerta('Favor de agregar un archivo para la fila', null, null);
      
      
      console.log("LISTA_ARCHIVOS:::",this.LISTA_ARCHIVOS)
},

  agregarColumna:function(){
            this.columnasTablaContenido.push(this.NombreColumna)
            this.NombreColumna=null;
        },
  eliminarColumna:function(columna){
            let listaAuxiliar=[];
              var i = this.columnasTablaContenido.indexOf( columna );
              console.log("iiiii:::",i);
 
             if ( i !== -1 ) {
                  this.columnasTablaContenido.splice( i, 1 );
             }

              this.nuevasFilas.forEach(element => {
                 var elemntoAuxiliar = element.split("|");
                 elemntoAuxiliar.splice(i,1);
                 let nuevafila="";
                 elemntoAuxiliar.forEach(subelemento => {

                    nuevafila = nuevafila+subelemento+"|";
                    listaAuxiliar.push(nuevafila.slice(0,-1)) 
                 })

                 element = nuevafila;
             })

             this.nuevasFilas = listaAuxiliar;           
        },
eliminarFila:function(fila){
  

this.nuevasFilas.splice(fila,1);
this.LISTA_ARCHIVOS = this.LISTA_ARCHIVOS.filter(s => s.index != fila);
},

cancelarEdicion:function(){
     this.limpiarFormulario();
     this.obtenerListadoDeContenidos();
     this.mostrarErroresInput = false;
    $("#ordenar-tab").removeClass("disabled");
     this.$emit('ocultarTooltip','disable');
     this.sobreescribirArchivo = false;
     this.evtOcultaFormulario();
     
},

evtOcultaFormulario(){
    var ocultarFormulario ={ocultaFormulario:false,tipoTablaCarrusel:this.contenido.TipoTablaCarrusel};
    this.$emit('OcultarFormulario',ocultarFormulario);
},

             limpiarArchivo:function(){
           
                    this.ARCHIVO_DESCARGA = null;
                    this.vinculo=null;
                    this.mostrarSubidorDeArchivos = false;
                    

        },

        limpiarImagen:function(){
           
                    this.IMAGEN_CONTENIDO = null;
                    this.mostrarSubidorDeArchivos = false;
                    

        },

valoresDeColumnas:function(){
 let numColumnas = this.numeroDeColumnas.length;
                let textoFinal='';

                for(var aux=0; aux< numColumnas;aux++){
                    textoFinal = textoFinal.concat(this.numeroDeColumnas[aux],'/');
                }
},
       
         /**
         * Metodo para manejar evento de datepicker fecha inicial. 
         * verifica si la fecha de inicio es menor para actualizar el valor de fecha
         * final dinamicamente.
         */
        seleccionDeFechaDtPkInicio: function() {
            this.$nextTick(() => {
              //  let fechaInicio = this.obtenerFecha(this.fechaDatePickerInicio);
              let fechaInicio = this.obtenerFecha(this.contenido.FechaDePublicacion);
              let fechaFinal = this.obtenerFecha(this.fechaDatePickerfinal);
                if(fechaInicio > fechaFinal) {
                    this.fechaDatePickerfinal = this.fechaDatePickerInicio;
                    this.fechaDefaultDtPkFinal = this.fechaDatePickerInicio;
                }
            });
        },
        /**
         * Metodo para manejar evento de datepicker fecha inicial. 
         * En caso de no requerirse eliminar metodo
         */
        seleccionDeFechaDtPkFin: function() {
           // de momento no hay logica aqui utilizar despues
        },




    agregarDatosParaContacto: function() {
              
        if(this.tituloContacto!=null && this.descripcionContacto!=null){
            
            if(!/\s+$/.test(this.tituloContacto) && !/\s+$/.test(this.descripcionContacto)){
            let objetoContacto = {};
          objetoContacto.id = (this.listaDeArchivos.length + 1);
          objetoContacto.Titulo = this.tituloContacto;
          objetoContacto.TextoDescripcion = this.descripcionContacto;
          if(this.EsLink){
              objetoContacto.TextoDescripcion="EsLink";
              objetoContacto.RutaDelArchivo = this.descripcionContacto;
          }
          this.listaDeArchivos.push(objetoContacto);
          this.tituloContacto=null;
          this.descripcionContacto=null;
          this.EsLink=false;
          $('#noEsLink').attr('checked',true);
            }else  comun.mensajeDeAlerta("Campos solo con espacios, favor de ingresar el tipo de contacto y la descripcion de contacto", null, null);

        }else comun.mensajeDeAlerta("Se detectaron campos vacíos, favor de ingresar el tipo de contacto y la descripcion de contacto", null, null);
        },
        /**
         * Metodo para agregar elemtos tipo archivo al listado que tendra el contenido que se dara de alta,
         * valida si el contenido requiere lista de archivos o solo un archivo.
         */
        agregarArchivosAcontenido: function() {
              if(this.listaDeArchivos.length == 1) {
                 comun.mensajeDeAlerta('Este contenido solo necesita un archivo o viculo a otra pagina ya has agregado uno,<br>Si deseas cambiar el archivo presione el icono de eliminar y repita el proceso para agregar un archivo o vinculo a otra pagina', null, null);
             }
             else {
                this.agregarArchivoEnListado();
             }
          
        },
        /**
         * Metodo encargado de construir objeto tipo archivo y posteriormente agregarlo al listado de archivos.
         */
        agregarArchivoEnListado: function() {
           
             let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
             let camposValidos = true;
             let identificadoresDeArchivo = this.identificardorTipoRutaArchivo();
            
             if(this.campoEsValidoFormulario(identificadoresDeArchivo.rutaDelArchivo)) {
                 let vinculoAotraPaginaEncontrado = this.existeVinculoAotraPagina();
                 if(identificadoresDeArchivo.nombreServidor == 'VinculoPrincipal' && vinculoAotraPaginaEncontrado.existe) {
                     comun.mensajeDeAlerta(`Solo se permite un vinculo a otra pagina y has agregado uno [${vinculoAotraPaginaEncontrado.nombreDelVinculo}], <br>Si deseas cambiar el vinculo a otra pagina presione el icono de eliminar y repita el proceso para agregar un vinculo a otra pagina`, null, null);
                 }  
                 else if( this.listaDeArchivos.length >= 1 && this.existeUnArchivoConEsteNombre(identificadoresDeArchivo.nombreBase,identificadoresDeArchivo.nombreServidor)) {
                     comun.mensajeDeAlerta('No se permiten archivos con el mismo nombre, <br>Cambia el nombre del archivo o elimina el que se encuentra en la lista', null, null);
                 }
                 else {
                     let objetoArchivo = {};            

                     objetoArchivo.NombreBase = identificadoresDeArchivo.nombreBase;             
                     objetoArchivo.NombreEnServidor = identificadoresDeArchivo.nombreServidor;
                     objetoArchivo.RutaDelArchivo = identificadoresDeArchivo.rutaDeArchivo;
                     objetoArchivo.Titulo = (this.campoEsValidoFormulario(this.tituloArchivo))? this.tituloArchivo : 'Sin título';
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.TextoDelVinculo = this.textoVinculoArchivo;
                     objetoArchivo.EsImagen = false;
                     objetoArchivo.Activo = true;
                     objetoArchivo.TextoDescripcion = (this.campoEsValidoFormulario(this.textoVinculoArchivo))? this.textoVinculoArchivo : 'Sin texto de vínculo';                   
                    
                     this.listaDeArchivos.push(objetoArchivo);
                  
                     this.existePerdidaDeCambios = true;
                    
                     this.listaDeArchivosBit[objetoArchivo.RutaDelArchivo] = this.ARCHIVO_DESCARGA;
                     
                     this.contadorArchivos ++;
                   
                     this.limpiarApartadoArchivosFormulario();
                    
                     let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
                     
                   //  if(camposRequeridos.listaDeArchivos.requerido) {
                         comun.mensajeDeAlerta(`El ${this.textoBotonAgregaraAoV} se agregó correctamente`, null, null);
                     //}
                 }
               
             }
             
        },
  
      
        
        /**
         * Metodo encargado de identificar si se requiere subir archivo con vinculo o directamete desde el inpu
         */
        validarOpcionToggleArchivo: function() {
            let mostrar = true;
            // let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
            // if(!camposRequeridos.archivoConVinculo.requerido && this.descargaRadio) {
            //     mostrar = true;
            // }
            // else if(camposRequeridos.archivoConVinculo.requerido && descargaRadio && descargaArchivoRadio){
            //     mostrar = true;
            // }
            return mostrar;
        },
        /**
         * Metodo encargado de verificar si ya existe un vinculo a otra pagina en el listado
         * @returns {boolean} existeVinculoAotraPagina [variable que representa si ya existe el archivo o no]
         */
        existeVinculoAotraPagina: function() {
          
            let vinculoAotraPaginaEncontrado = {
                nombreDelVinculo: null,
                existe: false
            };
            if(this.listaDeArchivos.length > 0) {
                this.listaDeArchivos.filter(a => a.NombreEnServidor == 'VinculoPrincipal').forEach(archivo => {
                    vinculoAotraPaginaEncontrado.existe = true;
                    vinculoAotraPaginaEncontrado.nombreDelVinculo = archivo.NombreBase;
                });
            }
            return vinculoAotraPaginaEncontrado;
        },
         /**
         * Metodo encargado de verificar si ya existe un archivo con el mismo nombre 
         * @param {String} nombreDeArchivo [nombre del archivo a comparar]
         * @param {String} esVinculoOarchivo [indica si el elemento que se agregara al listado es vinculo a otra pagina, vinculo de archivo o archivo]
         * @returns {boolean} existeArchivo [variable que representa si ya existe el archivo o no]
         */
        existeUnArchivoConEsteNombre: function(nombreDeArchivo,esVinculoOarchivo) {
            let existeArchivo = false;
            if(this.listaDeArchivos.length > 0 && esVinculoOarchivo != 'VinculoPrincipal') {
                this.listaDeArchivos.filter(a => a.NombreBase == nombreDeArchivo && a.NombreEnServidor != 'VinculoPrincipal').forEach(archivo => {
                    existeArchivo = true;
                });
            }
            return existeArchivo;
        },
        /**
         * Metodo encargado para clasificar si el usario desea cargar un archivos desde el fromulario o cargarlo desde un vinculo
         * para posteriormente contruir el objeto del archivo. 
         * @see {@link agregarArchivoEnListado}
         * @returns {object} identificadoresDeArchivo [objeto con la estructura de la entidad ArchivosDeContenido]
         */
        identificardorTipoRutaArchivo: function() {
      
            const nombreInicialTipoArchivo = 'Archivo';
            const nombreInicialTipoVinculo = 'Vinculo';
            const nombreInicialTipoVinculoPrincipal = 'VinculoPrincipal';
             let identificadoresDeArchivo = {};
            if(this.vinculoRadio) {
                
                this.textoVinculoPrincipal = this.vinculo;
                
                identificadoresDeArchivo.rutaDelArchivo = this.vinculo;
                identificadoresDeArchivo.nombreServidor = nombreInicialTipoVinculoPrincipal;
                identificadoresDeArchivo.mensajeError = 'No has ingresado ningún vinculo a otra pagina,<br>Debes ingresar un vinculo valido a otra pagina';
                identificadoresDeArchivo.nombreBase = this.vinculo;
            }
            else if (this.descargaRadio){
                if(this.vinculoArchivoRadio){
                    identificadoresDeArchivo.rutaDelArchivo = this.vinculo;
                    identificadoresDeArchivo.nombreServidor = nombreInicialTipoVinculo + this.contadorArchivos;
                    identificadoresDeArchivo.mensajeError = 'No has ingresado ningún vinculo para el archivo,<br>Debes ingresar un vinculo para poder agregar el archivo';
                    identificadoresDeArchivo.nombreBase = this.vinculo;
                }
                 else {
                     identificadoresDeArchivo.rutaDelArchivo = this.ARCHIVO_DESCARGA;
                     identificadoresDeArchivo.nombreServidor = nombreInicialTipoArchivo + this.contadorArchivos;
                     identificadoresDeArchivo.mensajeError = 'No hay ningún archivo seleccionado,<br>Debes tener un archivo seleccionado para poder agregar el archivo';
                     identificadoresDeArchivo.nombreBase = this.campoEsValidoFormulario(this.ARCHIVO_DESCARGA) ? this.ARCHIVO_DESCARGA.name : null;
                 }
            }
            return identificadoresDeArchivo;
        },
         /**
         * Metodo encargado para limpiar las variables relacionadas con el apartado de archivos dentro del fromulario.  
         */
        limpiarApartadoArchivosFormulario: function() {
                  $("#descarga_contenido").val('');
                  this.ARCHIVO_DESCARGA = null;
                  this.tituloArchivo = null;
                  this.vinculo = null;
                  this.textoVinculoArchivo = null;
             
        },
         /**
         * Metodo encargado de remover items de la lista de archivos.
         * @param {object} evento [evento emitido por el icono de eliminar dentro de la tabla correspondiente al listado de archivos]
         */
        removerArchivoDeLista: function(evento) {
            
            let llaveArchivo = evento.target.getAttribute('id');
            const indexDeElemento = this.listaDeArchivos.findIndex(archivo => archivo.NombreEnServidor == llaveArchivo);
            if(indexDeElemento > -1) {
                this.listaDeArchivos.splice(indexDeElemento, 1);
                delete this.listaDeArchivosBit[llaveArchivo];
                if(this.listaDeArchivos.length < 1){
                    this.existePerdidaDeCambios = false;
                }
            }
        },
         /**
         * Metodo encargado de remover todos los items de la lista de archivo y reiniciar el contador.
         */
        vaciarListaArchivosAgregados: function() {
            this.listaDeArchivos = [];
            this.contadorArchivos = 0;
            this.listaDeArchivosBit = new Object();
            this.existePerdidaDeCambios = false;
        },
        /**
         * Metodo encargado de regresar al paso uno, validando previamente si el usuario no a guardado cambios dentro del formulario y
         * llamando al API para cambiar el estatus enEdicion de la saccion a false (no se esta editando).
         */
        cambioDeSeccion: function() {
           this.validarFormulario(null);
            if(this.existePerdidaDeCambios && this.modificoOrdenDeContenidos)
            {
                this.informarPerdidaDeCambiosEnFormularioYOrden();
            }
            else if(this.existePerdidaDeCambios || this.listaDeArchivos.length > 0) 
            {
                this.informarPerdidaDeCambiosFormularioContenido();
            }
            else if(this.modificoOrdenDeContenidos)
            {
                this.informarPerdidaDeCambiosOrdenContenidos(false);
            }
            else 
            {
                this.cambiarEstatusSeccion();
            }
        },
        /**
         * Metodo encargado de ocultar componente correspondiente al paso dos.
         */
        ocultarPasoDos: function() {
            $("#contenedor-pasoUno").removeClass("desabilitar-div-pasoUno");
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerMostrarFormularios",false);
            this.limpiarFormulario();
        },
        /**
         * Metodo encargado validar si el contenido requiere textoDelVinculo.
         * @returns {boolean} mostrar [variable que representa si se debe mostrar el campo dentro del formulario]
         */
        mostrarTextoDelVinculo: function() {
            let mostrar = true;
             const PAGINA_WEB_CONVOCATORIA = 3;
             const PAGINA_WEB_BOLETIN_ELECTRONICO = 29;
            return mostrar;
        },
         /**
         * Metodo encargado de agregar contenido en base de datos valida previamente la existencia de perdida de cambios
         * en la pestaña Modificar orden del contenido. 
         * @see {@link informarPerdidaDeCambiosOrdenContenidos}
         * @see {@link agregarContenidoBD}
         */
        agregarContenido: function() {
            if(this.modificoOrdenDeContenidos){
                this.informarPerdidaDeCambiosOrdenContenidos(true);
            }else{
                this.agregarContenidoBD();
            }
        },
         /**
         * Metodo encargado de llamar a la API para guardar contenido en base de datos. 
         */
        agregarContenidoBD: function() {
//  $("#ordenar-tab").removeClass("disabled")

             let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
             let validaVinculo = true;
             let validaAdicional = true;


if(camposRequeridos.RutaDeVideoRequerido && this.rutaVideo!=""){
if(this.rutaVideo!=null && !this.validarVinculoURL(this.rutaVideo) ) validaVinculo= false;
}

//////////// VALIDACION DE ARCHIVO ADICIONAL //////////////////    
if(this.tieneArchivoAdicional){
    if(this.textoVinculoArchivo==null || this.textoVinculoArchivo=='') {
        this.validaVinculoArchivoAdicional = false;
         this.textoMensajeCampoFaltante='No has ingresado el texto del vinculo';
    }
    else  this.validaVinculoArchivoAdicional = true;
  
    if(this.contenido.ArchivoAdicional==null && this.ARCHIVO_DESCARGA==null){
        this.validaArchivoAdicional = false;
        this.textoMensajeCampoFaltante='No has seleccionado ningun archivo';
    } 
    else  this.validaArchivoAdicional = true;
   
   validaAdicional = (this.validaArchivoAdicional && this.validaVinculoArchivoAdicional)?true:false;
}
//////////// VALIDACION DE ARCHIVO ADICIONAL //////////////////




             if(this.validarFormulario() && validaVinculo && validaAdicional) {
                          
                      const SERVIDOR = api.conexion;             
                      const METODO_API_AGREGAR = api.SICPO.sistema.micrositioweb.edicioncontenidomicrositio.EditarContenidoDeMicrositio;
                    
                     let urlApi = SERVIDOR + METODO_API_AGREGAR;
                     
                      let peticionAPI = this.crearPeticion();
                      console.log("PETICION::::",peticionAPI)
                       let peticionArchivos = true;
                       let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
                         comun.SeEstaCargandoInformacion(true);
                         axios.post(urlApi, peticionAPI, headerPeticion)
                                  .then(respuesta => {            
                                      if (respuesta.data.SiHayError) {                                                      
                                          let mensajeError = respuesta.data.Error.Mensaje;
                                          console.log(respuesta.data.Error)
                                          this.informarError(mensajeError);
                                      } else {
                                          this.limpiarFormulario();
                                          this.obtenerListadoDeContenidos();
                                          this.mostrarErroresInput = false;
                                          $("#ordenar-tab").removeClass("disabled");
                                          this.$emit('ocultarTooltip','disable');
                                          this.sobreescribirArchivo = false;
                                          this.evtOcultaFormulario();
                                          comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                                      }
                                      comun.SeEstaCargandoInformacion(false);
                                 })
                                  .catch(excepcion => {
                                      comun.SeEstaCargandoInformacion(false);
                                      console.log(excepcion);
                                      this.informarError(excepcion.message);
                                 });  
                  
             }
              else {
                 if(validaVinculo || validaArchivoAdicional) comun.mensajeDeAlerta(this.textoMensajeCampoFaltante, null, null);
                  this.mostrarErroresInput = true;
                   this.textoMensajeCampoFaltante = '';
              }
        },
        /**
         * Metodo hacer el llamado a API para cambiar el estatus de la sección. 
         * @param {bool} enEdicion [estatus de seccion]
         */
        cambiarEstatusSeccion:function(){         
                                this.ocultarPasoDos();                    
        },
         /**
         * Metodo encargado para clasificar errores arrojados por excepciones y posteriormente informarlo al usuario. 
         * @param {String} error [mensaje de la excepcion capturada]
         */
        informarError: function(error) {
            switch(error){
                case 'Network Error':
                    this.manejoErrorArchivoNoEncontrado();
                    break;
                case 'Ya existe el archivo de descarga seleccionado':
                    this.informarSobreescrituraDeArchivos(error);
                    break;
                case 'Ya existe la imagen del comunicado seleccionada':
                    this.informarSobreescrituraDeArchivos(error);
                    break;
                default:
                    comun.mensajeDeAlerta(error, null, null);
                    break;
            }
        },
         /**
         * Metodo encargado para manejar el error FileNotFound en navegador. 
         */
        manejoErrorArchivoNoEncontrado: function() {
            const mensajeErrorImagen = 'Recurso no encontrado por favor verifique los campos imagen del contenido y archivo de descarga';
            const mensajeErrorArchivoDescarga = 'Recurso archivo de descarga no encontrado por favor verifique el campo';
            if(this.obtenerCamposRequeridosEnFormulario.RequiereCamposDeComunicado) {
                comun.mensajeDeAlerta(mensajeErrorImagen, null, null);  
            }
            else {
                comun.mensajeDeAlerta(mensajeErrorArchivoDescarga, null, null);
            }
        },
         /**
         * Metodo encargado para asignar valor de input correspondiente a la imagen a la variable IMAGEN_CONTENIDO que 
         * posteriormente se enviara en la peticon para el alta de contenido. 
         * @param {object} evento [evento emitido por el input tipo file correspondiente a la imagen]
         */
        subirImagen: function(evento) {
            try{
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'IMAGEN')) {
                        this.IMAGEN_CONTENIDO = evento.target.files[0];
                        this.mostrarSubidorDeArchivos = true;
                       
                    }
                    else {
                        $("#imagen_contenido").val('');
                        this.IMAGEN_CONTENIDO = null;
                        comun.mensajeDeAlerta('Para las imagenes solo se permiten extensiones JPEG,JPG y PNG,<br>Seleccione otra imagen con una de las siguientes extensiones JPEG,JPG o PNG');
                    }
                }
                else {
                    this.IMAGEN_CONTENIDO = null;
                    this.mostrarSubidorDeArchivos = false; 
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },



 subirArchivoVideo: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'VIDEO')) {
                        this.VIDEO_CONTENIDO = evento.target.files[0];
                        this.mostrarSubidorDeArchivos = true;
                    }
                    else {
                        $("#descarga_video").val('');
                        this.VIDEO_CONTENIDO = null;
                        comun.mensajeDeAlerta('Para los archivos de descarga solo se permiten extensiones MP4, AVI y W,<br>Seleccione otro archivo con una de las siguientes extensiones PDF,XLSX,XLSB o ZIP');
                    }
                }
                else {
                    this.VIDEO_CONTENIDO = null;
                    this.mostrarSubidorDeArchivos = false;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
   
         /**
         * Metodo encargado para asignar valor de input correspondiente para archivo hacia la variable ARCHIVO_DESCARGA que 
         * posteriormente se enviara en la peticon para el alta de contenido. 
         * @param {object} evento [evento emitido por el input tipo file correspondiente al archivo]
         */
        subirArchivoDescarga: function(evento) {
            try {
                if(evento.target.files.length > 0) {
                    const NOMBRE_DE_ARCHIVO = evento.target.files[0].name;
                    if(this.verificaQueSeaElDocumentoCorrecto(NOMBRE_DE_ARCHIVO,'DESCARGA')) {
                        this.ARCHIVO_DESCARGA = evento.target.files[0];
                        this.mostrarSubidorDeArchivos = true;
                    }
                    else {
                        $("#descarga_contenido").val('');
                        this.ARCHIVO_DESCARGA = null;
                        comun.mensajeDeAlerta('Para los archivos de descarga solo se permiten extensiones PDF,XLSX,XLSB y ZIP,<br>Seleccione otro archivo con una de las siguientes extensiones PDF,XLSX,XLSB o ZIP');
                    }
                }
                else {
                    this.ARCHIVO_DESCARGA = null;
                    this.mostrarSubidorDeArchivos = false;
                }
            }
            catch(error) {
                comun.mensajeDeAlerta(error);
            }
        },
        verificaQueSeaElDocumentoCorrecto: function(nombreArchivo,tipoDocumento) {
            const NOMBRE_CORTADO = nombreArchivo.split(".");
            let siEsUnDocumentoValido = false;
            switch(tipoDocumento) {
                case 'DESCARGA':
                    const EXTENSION_ARCHIVO = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_ARCHIVO === 'PDF' || EXTENSION_ARCHIVO === 'XLSX' || EXTENSION_ARCHIVO === 'XLSB' || EXTENSION_ARCHIVO === 'ZIP')
                        siEsUnDocumentoValido = true;

                    break;
                case 'IMAGEN':
                    const EXTENSION_IMAGEN = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_IMAGEN === 'JPEG' || EXTENSION_IMAGEN === 'JPG' || EXTENSION_IMAGEN === 'PNG')
                        siEsUnDocumentoValido = true;
                        
                    break;

                       case 'VIDEO':
                    const EXTENSION_VIDEO = NOMBRE_CORTADO[NOMBRE_CORTADO.length - 1].toUpperCase();
                    if(EXTENSION_VIDEO === 'MP4' || EXTENSION_IMAGEN === 'AVI' || EXTENSION_IMAGEN === 'WMV')
                        siEsUnDocumentoValido = true;
                        
                    break;
                default:
            }
            return siEsUnDocumentoValido;
        },
       
        transformarImagenesPredeterminadasParaCatalogo: function(listaImagenes) {
            let ListadoImagenesPredeterminadas = [];
            if(listaImagenes != null && listaImagenes.length > 0) {
                listaImagenes.forEach((img)=>{
                    let objImg = {
                        llave: img.ImagenPredeterminadaId,
                        imagen: img.RutaDeLaImagen
                    }
                    ListadoImagenesPredeterminadas.push(objImg);
                });
            }
            return ListadoImagenesPredeterminadas;
        },
         /**
         * Metodo encargado de crear la peticion para el alta de contenido, haciendo una iterando la lisa de archivos
         * para enviarlos como parametros independientes posteriormente se agrega a un objeto con la estructura de la
         * entidad de contenido finalmente se convierte el objeto contenido a JSON y se agrega como parametro. 
         */
        crearPeticion: function() {
           let datosDelFormulario = new FormData();
            let seccionId = this.$store.getters.Get_SICPO_Catalogo_014SeccionMicrositio.catalogoSeccionPasoUno;
            let contenidoIdMicrositio  = this.contenido.ContenidoDeMicrositioId;
            let paginaInicio = this.$store.getters.Get_SICPO_Catalogos_001PaginaInicio.catalogoPaginaPasoUno;
            let conArchivosContenido = false;//this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario.tipoDeFormulario == 'comunicado'? true : false;
            let formato = this.$store.getters.Get_SICPO_Catalogo_FormatoDeSeccion.valor;
            let conArchivoAdicional=false;
            let conArchivo = false;
            let esCarrusel = false;
            let esTabla = false;
            let esContacto = false;
            let ContenidoConTabla = false;
            let contenido = {};
             

            
           
            contenido.TextoDelContenido =  this.textoDelContenido;//this.construirDescripcionContenido(paginaId,esSeccion);
            contenido.TextoDelVinculo = this.textoVinculo;
            contenido.FechaDePublicacion = (this.fechaDatePickerInicio!=null)?this.fechaDatePickerInicio:moment().format("DD-MM-YYYY");
            contenido.AbrirEnVisor = this.visualizarEnVisor;

            let llaveImagen = this.IMAGEN_CONTENIDO !=null ? 'Imagen': this.imagenDeObligacion;
            contenido.RutaDeImagen = llaveImagen;

            let llaveArchivo = this.ARCHIVO_DESCARGA ?'ArchivoDescarga':null;
            contenido.RutaDeArchivo = llaveArchivo;
              let llaveVideo = this.VIDEO_CONTENIDO ?'Video':null;

if(formato==18){
    contenido.TextoDelVinculo=this.textoVinculoArchivo;
    contenido.TamanoDeLaColumna = 12;
}

            if(formato == 26){
                contenido.ArchivosDeContenidoMicrositios = this.listaDeArchivos;
                contenido.TextoDelContenido = this.titulo;
                contenido.TamanoDeLaColumna = 6;
                // this.esComunicado=false;         
            }
            if(formato == 8){
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                contenido.TamanoDeLaColumna = 6;
                conArchivo = true;
                // this.esComunicado=false;
                if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                }
            }

            if(formato == 16){
                contenido.TamanoDeLaColumna = 12;
                conArchivo = true;
                // this.esComunicado=false;
               
               if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }

             if(formato == 19){
                contenido.TamanoDeLaColumna = 4;
                conArchivo = true;
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                // this.esComunicado=false;

                 if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }

             if(formato == 20){
                contenido.TamanoDeLaColumna = 4;
                conArchivo = true;
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                // this.esComunicado=false;
                if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }

            if(formato == 21){
                contenido.TamanoDeLaColumna = 7;
                conArchivo = true;
                contenido.TextoDelContenido = this.titulo + '|'+this.textoDelContenido;
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                // this.esComunicado=false;

                if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }

            if(formato == 24){
                contenido.TamanoDeLaColumna = 12;
                // this.esComunicado=false;
            }

            if(formato == 25){
                contenido.TamanoDeLaColumna = 12;
                // this.esComunicado=false;
            }
            if(formato == 28){
                contenido.TamanoDeLaColumna = 12;
                conArchivo = true;
                contenido.TextoDelVinculo = this.textoVinculoArchivo;
                // this.esComunicado=false;
                if(this.vinculoArchivoRadio) {
                    contenido.RutaDeArchivo = this.vinculo;
                    conArchivo = false
                    }
            }
            if(formato == 30){
                let numColumnas = this.numeroDeColumnas.length;
                let textoFinal='';

                for(var aux=0; aux< numColumnas;aux++)
                    textoFinal = textoFinal.concat(this.numeroDeColumnas[aux],'|');

                contenido.TextoDelContenido = textoFinal.slice(0,-1);
                contenido.TamanoDeLaColumna = 12;
                // this.esComunicado=false;
            }

            contenido.Activo = true;
         
            


             if(formato == 17){
                contenido.RutaDeArchivo = this.rutaVideo;
                 if(this.subirVideo){
                        contenido.RutaDeArchivo = llaveVideo;
                 }
                 contenido.TamanoDeLaColumna = 4;
                //  this.esComunicado=false;
                 contenido.TextoDelVinculo = this.tituloVideo;
     
            }

            if(formato == 27){
                contenido.ArchivosDeContenidoMicrositios = this.listaDeArchivos;         
                contenido.RutaDeArchivo = this.rutaVinculo;
                contenido.TextoDelContenido = this.titulo;
                contenido.TamanoDeLaColumna = 12;
                // this.esComunicado=false;
                esContacto =true;
            }

            if(formato == 32){ 
                this.listaDeArchivos = [];

                 let objetoArchivo = {};
                     objetoArchivo.ContenidoDeMicrositioId = parseInt(this.$store.getters.Get_SICPO_Catalogo_015ContenidoMicrositio.contenidoMicrositioId);
                     objetoArchivo.NombreBase =(this.IMAGEN_CONTENIDO!=null)?this.IMAGEN_CONTENIDO.name:null;             
                     objetoArchivo.NombreEnServidor = (this.IMAGEN_CONTENIDO!=null)?this.IMAGEN_CONTENIDO.name:null;
                     objetoArchivo.RutaDelArchivo = llaveImagen;
                     objetoArchivo.ArchivoDeContenidoMicrositioId = this.contenido.ArchivoDeContenidoMicrositioId;
                     objetoArchivo.Titulo = this.tituloCarrusel;
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.EsImagen = true;
                     objetoArchivo.Activo = true;
                     objetoArchivo.TextoDescripcion = this.textoDelContenido;
                     objetoArchivo.ArchivoAdicional = llaveArchivo;
                     objetoArchivo.TextoLink =  this.textoVinculoArchivo;
                     conArchivoAdicional = this.tieneArchivoAdicional;   
                     objetoArchivo.AbrirEnVisor = this.visualizarEnVisorAdicional;                   
                     this.listaDeArchivos.push(objetoArchivo);                 
                     esCarrusel = true
                     contenido.TamanoDeLaColumna = 12;
                    //  this.esComunicado=false;
            }




if(formato == 47){
    ContenidoConTabla = true;
    let i = 0;
    let textoCont = "";
    let titulosNuevaTabla="";
    
for(i=0;i<this.numeroDeColumnas.length;i++){
    textoCont = textoCont+this.numeroDeColumnas[i]+"|";
}
textoCont=textoCont.slice(0,-1);
     contenido.TextoDelContenido = textoCont ;
     contenido.TextoDelVinculo = this.textoVinculoArchivo;

for(i=0;i<this.columnasTablaContenido.length;i++){
    titulosNuevaTabla = titulosNuevaTabla+this.columnasTablaContenido[i]+"|";  
}
titulosNuevaTabla=titulosNuevaTabla.slice(0,-1);
 contenido.RutaDeImagen = titulosNuevaTabla;

for(i=0;i<this.nuevasFilas.length;i++){
    let objetoArchivo = {};
    let textoDesc="";
    var textoColumnas = this.nuevasFilas[i].split("|");
    objetoArchivo.TextoLink = textoColumnas.pop();
    let j=0
    textoColumnas.forEach(element => {
      if(j!=0)
        textoDesc = textoDesc+element+"|";
        
       j++
    });
    objetoArchivo.ArchivoDeContenidoMicrositioId=textoColumnas[0];
    objetoArchivo.TextoDescripcion=textoDesc.slice(0,-1);
    objetoArchivo.RutaDelArchivo="Code:DocContConTabla";
    objetoArchivo.AbrirEnVisor = true;    
    this.listaDeArchivos.push(objetoArchivo);
    conArchivosContenido = true;
}

}


             if(formato == 29 || formato == 22){
                 this.listaDeArchivos=[];
                 let objetoArchivo = {};
                //  let objetoComunicado = {};
                 objetoArchivo.ArchivoDeContenidoMicrositioId = this.contenido.ArchivosDeContenidoMicrositios[0].ArchivoDeContenidoMicrositioId;
                    if(this.descargaArchivoRadio){      
                     objetoArchivo.NombreBase = (this.ARCHIVO_DESCARGA!="" && this.ARCHIVO_DESCARGA!=null)?this.ARCHIVO_DESCARGA.name:"";             
                     objetoArchivo.NombreEnServidor = (this.ARCHIVO_DESCARGA!="" && this.ARCHIVO_DESCARGA!=null)?this.ARCHIVO_DESCARGA.name:"";
                     objetoArchivo.RutaDelArchivo = llaveArchivo;
                      conArchivosContenido=true;
                      }else{
                         objetoArchivo.RutaDelArchivo = this.vinculo;
                         conArchivosContenido=false;
                     }
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.EsImagen = false;
                     objetoArchivo.Activo = true;
                     objetoArchivo.TextoDescripcion = this.textoVinculoArchivo;
                     objetoArchivo.AbrirEnVisor = this.visualizarEnVisor;                   
                     this.listaDeArchivos.push(objetoArchivo);
                    if(formato == 22){
                        let numColumnas = this.numeroDeColumnas.length;
                        let textoFinal='';

                        for(var aux=0; aux< numColumnas;aux++){
                                textoFinal = textoFinal.concat(this.numeroDeColumnas[aux],'|');
                                contenido.TextoDelContenido = textoFinal.slice(0,-1);
                        }
                    }

                    //  if(this.esComunicado){
                    //      objetoComunicado.Titulo=this.tituloComunicado;
                    //      objetoComunicado.FechaPublicacion = this.fechaDatePickerInicio;
                    //      objetoComunicado.PaginaInicioId = paginaInicio;
                    //      objetoComunicado.Activo = this.esComunicado
                         
                    //  }

                // contenido.ComunicadosMicrositios = objetoComunicado;

               // conArchivosContenido=true;
                esCarrusel = false;
                esTabla=true;
                contenido.TamanoDeLaColumna = 12;
            }

      if( formato == 26){
          this.listaDeArchivos=[];
                 let objetoArchivo = {};
                //  let objetoComunicado = {};
                     objetoArchivo.ContenidoDeMicrositioId = parseInt(this.$store.getters.Get_SICPO_Catalogo_015ContenidoMicrositio.contenidoMicrositioId);
                     objetoArchivo.NombreBase =(this.ARCHIVO_DESCARGA != null)?this.ARCHIVO_DESCARGA.name:null;            
                     objetoArchivo.NombreEnServidor = (this.ARCHIVO_DESCARGA != null)?this.ARCHIVO_DESCARGA.name:null;    
                     objetoArchivo.ArchivoAdicional = llaveArchivo;
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.ArchivoDeContenidoMicrositioId = this.contenido.ArchivoDeContenidoMicrositioId;
                     objetoArchivo.EsImagen = false;
                     objetoArchivo.Activo = true;
                  //   objetoArchivo.TextoDescripcion = this.textoDelContenido;
                     objetoArchivo.AbrirEnVisor = this.visualizarEnVisor;
                     objetoArchivo.TextoLink = this.textoVinculoArchivo  
                      conArchivoAdicional = true;                  
                     
                 //   if(formato == 22){
                        let numColumnas = this.numeroDeColumnas.length;
                        let textoFinal='';
                        for(var aux=0; aux< numColumnas;aux++)
                                textoFinal = textoFinal.concat(this.numeroDeColumnas[aux],'|');
                                objetoArchivo.TextoDescripcion = textoFinal.slice(0,-1);
                 //   }
                    this.listaDeArchivos.push(objetoArchivo);
                //      if(this.esComunicado){
                //          objetoComunicado.Titulo=this.tituloComunicado;
                //          objetoComunicado.FechaPublicacion = this.fechaDatePickerInicio;
                //          objetoComunicado.PaginaInicioId = paginaInicio;
                         
                //      }

                // contenido.ComunicadosMicrositios = objetoComunicado;

                conArchivosContenido=true;
                esCarrusel = true;
                contenido.TamanoDeLaColumna = 12;
            }






            if(formato == 15){
                    this.listaDeArchivos = [];
                if(this.esImagen){
                     let objetoArchivo = {};               
                     objetoArchivo.ContenidoDeMicrositioId = parseInt(this.$store.getters.Get_SICPO_Catalogo_015ContenidoMicrositio.contenidoMicrositioId);
                     objetoArchivo.NombreBase = this.IMAGEN_CONTENIDO.name; 
                     objetoArchivo.ArchivoDeContenidoMicrositioId = this.contenido.ArchivoDeContenidoMicrositioId;            
                     objetoArchivo.NombreEnServidor = this.IMAGEN_CONTENIDO.name;
                     objetoArchivo.RutaDelArchivo = llaveImagen;                 
                     objetoArchivo.Titulo = this.tituloCarrusel;
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.EsImagen = true;
                     objetoArchivo.Activo = true;
                     objetoArchivo.TextoDescripcion = this.textoDelContenido;                   
                     objetoArchivo.AbrirEnVisor = false;  
                     this.listaDeArchivos.push(objetoArchivo);
                    
                  
                    esCarrusel = true
                    contenido.TamanoDeLaColumna = 12;
                    // this.esComunicado=false;
                }
                else if(this.esTexto){
                     let objetoArchivo = {};          
                     
                     objetoArchivo.ContenidoDeMicrositioId = parseInt(this.$store.getters.Get_SICPO_Catalogo_015ContenidoMicrositio.contenidoMicrositioId);                             
                      objetoArchivo.ArchivoDeContenidoMicrositioId = this.contenido.ArchivoDeContenidoMicrositioId;  
                     objetoArchivo.Titulo = this.tituloCarruselYTexto;
                     objetoArchivo.FechaDeRegistro = this.fechaDatePickerInicio;
                     objetoArchivo.EsImagen = false;
                     objetoArchivo.Activo = true;
                     objetoArchivo.AbrirEnVisor = false;  
                     objetoArchivo.TextoDescripcion = this.textoDelContenidoCarrusel;                   
                    
                     this.listaDeArchivos.push(objetoArchivo);
                               
                    esCarrusel = true;
                    // this.esComunicado=false;

                }
            }
           
 
            if(this.descargaRadio) {
                
                 this.listaDeArchivos = this.listaDeArchivos.filter(a => a.NombreEnServidor != 'VinculoPrincipal');
        
                 this.listaDeArchivos.filter(a => a.NombreEnServidor.includes('Archivo')).forEach(archivo => {
                
                    datosDelFormulario.append(archivo.NombreEnServidor,this.listaDeArchivosBit[archivo.NombreEnServidor]);
                     archivo.RutaDelArchivo = '';
                     archivo.Titulo = (archivo.Titulo == 'Sin título') ? null : archivo.Titulo;
                     archivo.TextoDelVinculo = (archivo.TextoDelVinculo == 'Sin texto de vínculo') ? null : archivo.TextoDelVinculo;
                 });
                 contenido.ArchivosDeContenidoMicrositios = this.listaDeArchivos;
             }
            if(this.IMAGEN_CONTENIDO !=null)
                datosDelFormulario.append(llaveImagen,this.IMAGEN_CONTENIDO);

                if(this.ARCHIVO_DESCARGA !=null)
                datosDelFormulario.append(llaveArchivo,this.ARCHIVO_DESCARGA);
                  
                  if(this.VIDEO_CONTENIDO!=null)
                datosDelFormulario.append(llaveVideo,this.VIDEO_CONTENIDO);
            
               if(this.LISTA_ARCHIVOS!=null){
                let i=0
                for(i=0;i<this.LISTA_ARCHIVOS.length;i++){
                    datosDelFormulario.append("listaArchivos",this.LISTA_ARCHIVOS[i].archivo);
                }
                    
            }

            contenido.ArchivosDeContenidoMicrositios = this.listaDeArchivos;
            console.log("contenido a editar::::",contenido);
             let contenidoJSON = JSON.stringify(contenido);
             datosDelFormulario.append('Contenido',contenidoJSON); 
             datosDelFormulario.append('ContenidoMicrositioId',contenidoIdMicrositio);
             datosDelFormulario.append('SeccionId',seccionId);
             datosDelFormulario.append('ConArchivosContenido', conArchivosContenido);
             datosDelFormulario.append('EsComunicado', this.esComunicado);
             datosDelFormulario.append('ConArchivo',conArchivo);
             datosDelFormulario.append('EsCarrusel',esCarrusel);
             datosDelFormulario.append('ConArchivoAdicional',conArchivoAdicional);
              datosDelFormulario.append('EsTabla',esTabla);
              datosDelFormulario.append('EsContacto',esContacto);
             datosDelFormulario.append('EsPrueba',false);
             datosDelFormulario.append('Formato',formato);
             datosDelFormulario.append('ContenidoConTabla',ContenidoConTabla);
             let submenuId = (this.disposicionEspecial) ? this.$store.getters.Get_SICPO_Catalogos_006Submenus.catalogoSubmenusPasoDos : -1;
             datosDelFormulario.append('SubmenuId',submenuId);
             datosDelFormulario.append('SubmenuTitulo',this.textoTituloSubmenu);
console.log("datos del formulario::: ",datosDelFormulario)
            return datosDelFormulario;
        },
        
         /**
         * Metodo encargado de inicializar el formulario (limpiar los input y variables ralcionadas con logica de alta de contenido). 
         */
        inicializarFormulario: function() {
            this.limpiarFormulario();
            this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioDeFormularioInput",false);

        },
        /**
         * Metodo encargado de limpiar cada una de las variables relacionadas con el formulario de alta de contenido. 
         */
        limpiarFormulario: function() {
          
            this.titulo = '';
            this.vinculo = null;
            this.textoDelContenido = null;
            this.textoVinculo = null;

            this.tituloCarruselYTexto=null;
            this.textoDelContenidoCarrusel = null;
            this.rutaVinculo = null;
            this.tituloContacto = null;
            this.descripcionContacto = null;
            this.numeroDeColumnas = [null];
            this.tituloCarrusel = null;
            this.rutaVideo = null;
            this.vinculo = null;

            
            $("#imagen_contenido").val('');
            $("#descarga_contenido").val('');
             
            this.IMAGEN_CONTENIDO = null;
            this.ARCHIVO_DESCARGA = null;
           
            this.fechaDePublicacion = '';
            this.fechaDePublicacionFin = '';
           
            this.limpiarOpcionesToggle();

            if(this.urgenteRadio) {
                this.urgenteRadio = true;
                this.informativoRadio = false;
            }
            else {
                this.urgenteRadio = false;
                this.informativoRadio = true;
            }
          
            this.listaDeArchivos = [];
            this.contadorArchivos = 0;
           
            this.textoVinculoArchivo = null;
            this.nombrePresidente = null;
            
            this.rangoPresidente = null;

            this.vinculoArchivo = false;
            this.textoBotonAgregaraAoV = 'Archivo'
           
            this.textoVinculoPrincipal = null;
            this.disposicionEspecial = false;
           
            this.esPin = false;
            this.textoTituloSubmenu = null;
            this.tituloComunicado=null;
           
            this.fechaDatePickerInicio = new Date();
            this.fechaDatePickerfinal= new Date();
             
            $('#' + this.imagenDeObligacion).prop('checked', false);
            this.imagenDeObligacion = null;
            
            $("#catalogo-poderes-pasoDos option:first").prop("selected", "selected");
            
        },
        /**
         * Metodo encargado de reiniciar los valores para las opciones toggle correspondientes al manejo de archivos 
         * y vinculos a otras paginas
         */
        limpiarOpcionesToggle: function() {
            if(this.descargaRadio) {
                this.vinculoRadio = false;
                if(this.descargaArchivoRadio) {
                    this.vinculoArchivoRadio = false;
                }
                else if(this.vinculoArchivoRadio) {
                     this.descargaArchivoRadio = false;
                }
            }
            else if(this.vinculoRadio) {
                this.descargaRadio = false;
                this.descargaArchivoRadio = true;
                this.vinculoArchivoRadio = false;
            }
        },
        /**
         * Metodo encargado de actualizar y recuperar el valor de existePerdidaDeCambios.  
         * @returns {boolean} existePerdidaDeCambios [representa si el formulario tiene información o no]
         */
        obtenerExistePerdidaDeCambios: function()
        {
            this.validarFormulario(null);
            return this.existePerdidaDeCambios;
        },
        /**
         * Metodo encargado de validar que los campos requeridos por el formulario no estan vacion o contengan datos incorrectos.  
         * @param {any} tipoDeFormulario [indicador para clasificar el tipo de formulario]
         * @returns {boolean} formularioValido [representa si el formulario es valido o no]
         */
        validarFormulario: function() {
            
             let camposRequeridos = this.obtenerCamposRequeridosEnFormulario;
             let camposAvalidar = [];
             let formularioValido = true;
             let input = {};

            if(camposRequeridos.TextoDelContenidoRequerido) {
                 input = {
                      campo: this.textoDelContenido,
                     mensaje: 'la descripcion'
                 }
                 
                  camposAvalidar.push(input)
              }
            
        
            if(camposRequeridos.RutaDeVideoRequerido ) {
                
                 let valor
                 if(this.rutaVideo==null || this.rutaVideo==""){ 
                        valor = this.rutaVideo;
                        if(this.VIDEO_CONTENIDO !=null) valor = this.VIDEO_CONTENIDO.name;
                }      
                input = {
                      campo:valor ,
                     mensaje: 'la ruta del video'
                 }                
                  camposAvalidar.push(input)

        
              }


            if(camposRequeridos.FechaPublicacionRequerido) {
                 input = {
                      campo: this.fechaDatePickerInicio,
                     mensaje: 'la fecha de publicación'
                 }
                  camposAvalidar.push(input)
              }

                                                     
            if(camposRequeridos.RutaDeImagenRequerido) {
                
                 input = {
                      campo: this.IMAGEN_CONTENIDO,
                     mensaje: ' la imagen del contenido'
                   }
                  camposAvalidar.push(input);
              }

              if(camposRequeridos.SeleccionaImagenOTexto){
                  if(this.esImagen){
                      
                      input={
                          campo:this.IMAGEN_CONTENIDO,
                          mensaje:'la imagen del contenido'
                      }
                      camposAvalidar.push(input);
                  }
                  else if(this.esTexto){
                      input={
                          campo: this.textoDelContenidoCarrusel,
                          mensaje:'la descripcion del contenido'
                      }
                      camposAvalidar.push(input);
                  }


              }

            if(camposRequeridos.RutaDelArchivoRequerido) {
                if(this.descargaArchivoRadio){
                  input = {
                      campo: this.ARCHIVO_DESCARGA,
                      mensaje: 'el archivo de descarga'
                 }
                  camposAvalidar.push(input)
                }
                else if(this.vinculoArchivoRadio){
                     input = {
                      campo: this.vinculo,
                      mensaje: 'el vínculo del archivo o pagína'
                 }
                  camposAvalidar.push(input)

                }
              }

              if(camposRequeridos.TextoDelVinculoRequerido) {
                  input = {
                      campo: this.textoVinculoArchivo,
                      mensaje: 'el texto del vínculo'
                 }
                  camposAvalidar.push(input)
              }

              if(camposRequeridos.TituloDelContenidoRequerido) {
                  input = {
                      campo: this.titulo,
                      mensaje: 'el titulo'
                 }
                  camposAvalidar.push(input)
              }


             if(camposRequeridos.ListaContactosRequerido) {
                  input = {
                      campo: this.listaDeArchivos,
                      mensaje: 'algun dato de contacto'
                 }
                  camposAvalidar.push(input)
              }

              if(camposRequeridos.RutaVinculoRequerido) {
                  input = {
                      campo: this.rutaVinculo,
                      mensaje: 'el vinculo del mapa'
                 }
                  camposAvalidar.push(input)
              }

               if(camposRequeridos.TextoColumnasRequerido) {
                                  
                 input = {
                      campo: this.numeroDeColumnas,
                      mensaje: 'los campos de las columnas'
                 }
                  camposAvalidar.push(input)
              }

              if(camposRequeridos.TituloCarruselTextoRequerido) {
                                  
                 input = {
                      campo: this.tituloCarruselYTexto,
                      mensaje: 'el titulo'
                 }
                  camposAvalidar.push(input)
              }

               if(camposRequeridos.TextoDelContenidoCarruselRequerido) {
                   
                 input = {
                      campo: this.textoDelContenidoCarrusel,
                      mensaje: 'el texto'
                 }
                  camposAvalidar.push(input)
              }

             formularioValido = this.validarCamposFormulario(camposAvalidar);
            return formularioValido;
        },
        validacionesEspecificasParaInput: function() {
            let validacionesRealizadas = true;
            if(this.vinculoRadio){
                let vinculoValido = this.validarVinculoURL(this.vinculo);
                if(!vinculoValido)
                    return vinculoValido;
            }
            return validacionesRealizadas;
        },
        validarVinculoURL: function(vinculo) {
            let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocolo
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // nombre del dominio
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // ip
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // puerto y ruta
                '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query de la peticion
                '(\\#[-a-z\\d_]*)?$','i'); // localizador de fragmentos
            let vinculoValido = !!pattern.test(vinculo);
            if(!vinculoValido)
                comun.mensajeDeAlerta('El vinculo no es valido,<br> por favor ingrese un vinculo valido, ejemplo www.vinculoPrueba.com');

            return vinculoValido;
        },
        /**
         * Metodo encargado de obtener la fecha actual con el formato [yyyy-mm-dd]
         */
        obtenerFecha: function(fecha) {
            let fechaActual = fecha;
            let mes = '' + (fechaActual.getMonth() + 1);
            let dia = '' + fechaActual.getDate();
            let year = fechaActual.getFullYear();

           if (mes.length < 2) 
               mes = '0' + mes;
            if (dia.length < 2) 
                dia = '0' + dia;

            return [year, mes, dia].join('-');
         
        },
        /**
         * Metodo encargado de validar los input correspondientes a fechas
         * fecha de publicación inicial >= fecha actual &&  fecha de publicación inicial < fecha de publicación final
         * fecha de publicación final > fecha de publicación inicial && fecha de publicación final > fecha actual
         */
        validarFechas: function() {
            let fechaValida = false;
            let fechaActual = this.obtenerFecha(new Date());
            let mensajeError = ['La fecha de publicación inicial no puede ser menor a la fecha actual, <br> por favor ingrese una fecha de publicación inicial valida'];
            if(this.fechaDePublicacion >= fechaActual) {
                fechaValida = true;
                mensajeError.pop();
            }
            if(this.urgenteRadio) {
                if(fechaValida && this.fechaDePublicacion < this.fechaDePublicacionFin) {
                    if(this.fechaDePublicacionFin > fechaActual) {
                         fechaValida = true;
                    }
                    else {
                        fechaValida = false;
                        mensajeError.push('La fecha final de publicacion no puede ser menor a la fecha actual, <br> por favor ingrese una fecha final de publicacion valida');
                    }
                }
                else {
                    fechaValida = false;
                    mensajeError.push('La fecha de publicacion inicial no puede ser mayor o igual a la fecha fin de la publicacion, <br> por favor ingrese una fecha de publicacion inicial valida');
                }
            }

            if(!fechaValida){
                comun.mensajeDeAlerta(mensajeError[0]);
            }
            return fechaValida;
        },
        /**
         * Metodo encargado de iterar lista de campos requridos por el formulario para posteriormente validar cada uno de los valores.  
         * @param {array} datosFormulario [arreglo compuesto de los capos requeridos por el formulario]
         * @returns {boolean} camposValidos [indica si los elementos de la lista de campos requeridos son validos]
         */
        validarCamposFormulario: function(datosFormulario) {
            let camposValidos = true;
            let existeValorIncorrecto = false;
            this.existePerdidaDeCambios = false;
            for (let i=0; i<datosFormulario.length; i++ ) {
                if(!existeValorIncorrecto){
                    camposValidos = this.campoEsValido(datosFormulario[i]);
                    if(!camposValidos){
                        existeValorIncorrecto = true;
                    }
                    else{
                        this.existePerdidaDeCambios = true;
                    }
                }
                else {
                    let resultadoTemporal = this.campoEsValido(datosFormulario[i]);
                    this.existePerdidaDeCambios = resultadoTemporal ? resultadoTemporal : this.existePerdidaDeCambios;
                }
            }
            return camposValidos;
        },
         /**
         * Metodo encargado de comparar si un valor del formulario esta vacio y si es obligatorio se asigna el valor del
         * mensaje que se mostrara al ususario en base al orden de los campos previamente establecidos.  
         * @param {any} input [valor a comparar]
         * @returns {boolean} campoValido [indica si el valor comparado esta vacio o no]
         */
        campoEsValido: function(input) {
            let campoValido = true;       
            if(Array.isArray(input.campo)){
                if(input.campo.length==0)
                    campoValido = false;
            } 
            else if (typeof input.campo === 'object')  {
                if(input.campo == null || input.campo == undefined){
                    campoValido = false;
                }
                
            } 
            else if(input.campo == null || input.campo == undefined || input.campo.trimEnd() == "" || /\s+$/.test(input.campo.trimEnd())) {
                campoValido = false;
                if(this.textoMensajeCampoFaltante =='')
                    this.textoMensajeCampoFaltante = 'Se detectaron campos vacios, favor de ingresar ' + input.mensaje + '.';
            }
            else if(this.textoMensajeCampoFaltante.includes(input.mensaje)) this.textoMensajeCampoFaltante = '';
            
            return campoValido;
        },
        /**
         * Metodo encargado de comparar si un valor esta vacio.  
         * @param {any} input [valor a comparar]
         * @returns {boolean} campoValido [indica si el valor comparado esta vacio o no]
         */
        campoEsValidoFormulario: function(input) {
            let campoValido = true;
            if(input == null || input == undefined || input == "") {
                campoValido = false;
            }
            return campoValido;
        },
        noHacerNada: function() {
            
        },
         /**
         * Metodo encargado de craer la peticion para obtener listado de contenidos de la base de datos.  
         * @returns {object} peticion [objeto con la estructura requerida para el consumo del metodo GET correspondiente del API]
         */
        crearPeticionListadoDeContenido: function() {
             let seccionId = this.$store.getters.Get_SICPO_Catalogo_014SeccionMicrositio.catalogoSeccionPasoUno;
            let paginaId  = this.$store.getters.Get_SICPO_Catalogos_013PaginaMicrositio.catalogoPaginaMicrositioPasoUno;
           
           //  let esComunicado = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_camposRequeridosFormulario.tipoDeFormulario == 'comunicado'? true : false;
            let peticion = {
               // PaginaWebId: paginaId,
                SeccionMicrositioId: seccionId,
                EsPrueba:false
               // EsComunicado: esComunicado
            }
            return peticion;
        },
        /**
         * Metodo de lamar a la API para obtener listado de contenidos.  
         */
        obtenerListadoDeContenidos: function() {
            
            const SERVIDOR = api.conexion;         
            const METODO_API_AGREGAR = api.SICPO.sistema.micrositioweb.altadecontenidomicrositio.ContenidosDeMicrositios;;
            let urlApi = SERVIDOR + METODO_API_AGREGAR;
            let peticionAPI = this.crearPeticionListadoDeContenido();
            let peticionArchivos = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
            axios.post(urlApi, peticionAPI, headerPeticion)
                    .then(respuesta => {            
                        if (respuesta.data.SiHayError) {
                            console.log(respuesta); 
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        } else {
                          
                            let listaDeCotenidosOriginal = [];            
                            let contenidosDePaginaWeb    = respuesta.data.ContenidosDeMicrositio;                         
                                this.ordenarDesc(contenidosDePaginaWeb,'contenido.OrdenDelContenido');                         
                                listaDeCotenidosOriginal = contenidosDePaginaWeb;                       
                            this.mapearInformacionParaListado(listaDeCotenidosOriginal);
                        }
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                    }
            ) // axios.post
        },

         ordenarAsc:function(p_array_json, p_key) {
                
                p_array_json.sort(function (a, b) {
                    return a[p_key] > b[p_key];
             });
                },
             ordenarDesc:function(p_array_json, p_key) {
                this.ordenarAsc(p_array_json, p_key); p_array_json.reverse(); 
                },
        /**
         * Metodo encargado de mapear el listado de contenidos obtenido por la API en un nuevo listado con la 
         * estructura requerida() para mostrar el listado en la pestaña modificar orden de contenido.
         * @see ListaOrdenableDeContenido.vue  
         * @param {array} listado [lista de contenidos]
         */
        mapearInformacionParaListado: function(listado) {     
            let listaContenidosOriginal = [];
            var urgenteVisibleId = -1;
            let hoy = new Date();
            var j =0;
            for(var i=listado.length;i>0;i--){
            
                let elementoContenido = {
                     id: i, 
                     mostrarDescripcion:false, 
                     hover:false,
                     conIconoUrgenteVisible: false,
                     conIconoMostrarEnInicio: true,
                     contenido: listado[j]
                     
                 }
                 listaContenidosOriginal.push(elementoContenido);
                 j++;
             }
           
            this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal",listaContenidosOriginal);
         
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar  posible perdida de cambios. 
         * @param {bool} guardarContenido [Si se quiere guardar contenido o cambiar seccion]
         * @see {@link agregarContenidoDB}
         * @see {@link cambiarEstatusSeccion}
         */
        informarPerdidaDeCambiosOrdenContenidos: function (guardarContenido) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Se detectaron cambios en la pestaña 'Modificar Orden de Contenidos', si deseas continuar " + (guardarContenido? "y cambiar de sección " : "") + "se perderán los cambios que no han sido guardados<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        if(guardarContenido)
                        {
                            this.agregarContenidoBD();
                            this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                        }
                        else{
                            this.cambiarEstatusSeccion(false);
                            this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                        }
                    }
                }
            });
        },
        /**
         * Metodo encargado de mostrar alerta bootbox para informar  posible perdida de cambios.
         * @see {@link cambiarEstatusSeccion}
         */
        informarPerdidaDeCambiosEnFormularioYOrden: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Has ingresado información en la pestaña de 'Agregar Contenido' y se detectaron cambios en la pestaña 'Modificar Orden de Contenidos', si deseas continuar y cambiar de sección se perderán los cambios que no fueron guardados<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.cambiarEstatusSeccion(false);
                        this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para acerca de sobreescritura de archivos. 
         * @param {string} mensajeR [mensaje que se quiera mostrar en alert]
         */
        informarSobreescrituraDeArchivos: function (mensajeR) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: mensajeR + ",<br> ¿deseas sobreescribir el archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.sobreescribirArchivo = true;
                        this.agregarContenidoBD();
                        this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que se removera un elemento de la lista de archivos. 
         * @param {object} evento [evento emitido por el item de la tabla de archivos]
         */
        informarSacarArchivoDeLista: function(evento) {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se eliminara el archivo de la lista,<br>¿Estas seguro de eliminar el archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.removerArchivoDeLista(evento);
                    }
                }
            });
        },



informarEliminarDatoDeLista: function(evento) {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se eliminara el archivo de la lista,<br>¿Estas seguro de eliminar el archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.removerDatoDeLista(evento);
                    }
                }
            });
        },


         removerDatoDeLista: function(evento) {
            let llaveArchivo = evento.target.getAttribute('id');   
            const indexDeElemento = this.listaDeArchivos.findIndex(archivo => archivo.index == llaveArchivo);        
            if(llaveArchivo > -1) {
                this.listaDeArchivos.splice(indexDeElemento, 1);
                delete this.listaDeArchivosBit[llaveArchivo];
                if(this.listaDeArchivos.length < 1){
                    this.existePerdidaDeCambios = false;
                }
            }
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que se agrego un elemento a la lista de archivos. 
         */
        informarVaciarListaDeArchivosAgregados: function() {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se eliminaran todos los archivos,<br>¿Estas seguro de eliminar todos los archivo?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.vaciarListaArchivosAgregados();
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que existe la posibilidad de perdida de cambios.
         * @see {@link cambiarEstatusSeccion} 
         */
        informarPerdidaDeCambiosFormularioContenido: function () {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: "Has ingresado información en la pestaña de 'Agregar Contenido', si deseas continuar y cambiar de sección se perderán los cambios que no han sido guardados<br>¿Desea continuar?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                         this.cambiarEstatusSeccion(false);
                    }
                }
            });
        },
         /**
         * Metodo encargado de mostrar alerta bootbox para informar que se vaciara la lista de archivos (en caso de manejar listado y cambiar de opcion toggle vinculo a otra pagina)
         */
        informarVaciarListaDeArchivos: function() {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Si cambias a la opcion vinculo a otra pagina se borraran los archivos que has agregado,<br>¿Estas seguro de cambiar a la opcion vinculo a otra pagina?",
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        this.listaDeArchivos = [];
                        this.vinculoRadio=true;
                        this.descargaRadio=false;
                        this.vinculo=null;
                        this.textoBotonAgregaraAoV = 'Vinculo';
                    }
                    else {
                        $("#vinculoRadio-toggle").removeClass('active');
                        $("#descargaRadio-toggle").addClass('active');
                    }
                }
            });
        },

        informarCamposDeListaDeContactoEstanVacios: function() {
             bootbox.confirm({
                title: "Mensaje del sistema",
                message:"Se detectaron campos vacios, favor de ingresar el tipo de contacto y/o descripcion de contacto",
                buttons: {                
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                   
                }
            });
        },
        acomodaContenidoEnFormulario:function(){       
        //console.log("this.contenido::",this.contenido);
        this.textoVinculoArchivo=this.contenido.TextoDelVinculo;
        this.visualizarEnVisor=this.contenido.AbrirEnVisor;
        this.imagenActual=this.contenido.RutaDeImagen;
        if(this.contenido.RutaDeArchivo!=null)
        this.archivoActual=this.contenido.RutaDeArchivo.split('\\')[this.contenido.RutaDeArchivo.split('\\').length-1];
        this.textoDelContenido=this.contenido.TextoDelContenido;
        //console.log("this.formatoId::",this.formatoId);
      
    //  this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion);
        switch(this.formatoId){
            case 15:
                this.esImagen = this.contenido.EsImagen;
                this.esTexto = (this.esImagen)?false:true;
                this.imagenActual=this.contenido.RutaDelArchivo;
               // this.fechaDatePickerInicio=this.contenido.FechaDeRegistro;
                this.tituloCarruselYTexto = this.contenido.Titulo;
                this.textoDelContenidoCarrusel = this.contenido.TextoDescripcion;
                 this.fechaDatePickerInicio=new Date(this.contenido.FechaDeRegistro+this.zonaHoraria);

                break;
            case 16:
                this.visualizarEnVisor=this.contenido.AbrirEnVisor;
                this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);

                break;
            case 32:
                this.tituloCarrusel = this.contenido.Titulo;
                this.textoDelContenido = this.contenido.TextoDescripcion;
                this.imagenActual=this.contenido.RutaDelArchivo;
              //  this.fechaDatePickerInicio=this.contenido.FechaDeRegistro;
                this.textoVinculoArchivo = this.contenido.TextoLink;               
                this.visualizarEnVisorAdicional= this.contenido.AbrirEnVisor;
                this.tieneArchivoAdicional=(this.contenido.ArchivoAdicional==null || this.contenido.ArchivoAdicional=='')?false:true;
                   this.fechaDatePickerInicio=new Date(this.contenido.FechaDeRegistro+this.zonaHoraria);
                break;
            case 30:
                for(var i=0;i<this.contenido.TextoDelContenido.split('|').length;i++){
                this.numeroDeColumnas[i]=this.contenido.TextoDelContenido.split('|')[i]
                }
                  this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);
                break;
            
            case 29:
                let ultimaPosicion = this.contenido.ArchivosDeContenidoMicrositios[0].RutaDelArchivo.split('\\').length - 1;
                this.archivoActual=this.contenido.ArchivosDeContenidoMicrositios[0].RutaDelArchivo.split('\\')[ultimaPosicion];
               if( this.contenido.ComunicadosMicrositios != null){
               this.esComunicado = this.contenido.ComunicadosMicrositios.Activo;
                this.tituloComunicado = this.contenido.ComunicadosMicrositios.Titulo
               }
                this.visualizarEnVisor=this.contenido.ArchivosDeContenidoMicrositios[0].AbrirEnVisor;
                this.textoVinculoArchivo=this.contenido.ArchivosDeContenidoMicrositios[0].TextoDescripcion;
                 this.contenido.RutaDeArchivo = this.contenido.ArchivosDeContenidoMicrositios[0].RutaDelArchivo;
                 this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);
                break;


            case 47:
                // let ultimaPosicionIndex = this.contenido.ArchivosDeContenidoMicrositios[0].RutaDelArchivo.split('\\').length - 1;
                 let textoDeColumnas = this.contenido.TextoDelContenido.split("|");
                  this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);
               
                 this.numeroDeColumnas= textoDeColumnas;
                 this.columnasTablaContenido = (this.contenido.RutaDeImagen!=null && this.contenido.RutaDeImagen!="")?this.contenido.RutaDeImagen.split("|"):[];          

                 this.contenido.ArchivosDeContenidoMicrositios.filter(f=>f.Activo==true).forEach(element => {
                      let fila = element.ArchivoDeContenidoMicrositioId+'|'+element.TextoDescripcion+'|'+element.TextoLink;
                      this.nuevasFilas.push(fila);
                 });




                  
                

                break;

            case 26:
                let ultimaPosicionTabla = this.contenido.ArchivoAdicional.split('\\').length - 1;
                this.archivoActual=this.contenido.ArchivoAdicional.split('\\')[ultimaPosicionTabla];
              // if( this.contenido.ComunicadosMicrositios != null){
              // this.esComunicado = this.contenido.ComunicadosMicrositios.Activo;
              //  this.tituloComunicado = this.contenido.ComunicadosMicrositios.Titulo
              // }
               for(var i=0;i<this.contenido.TextoDescripcion.split('|').length;i++){
                this.numeroDeColumnas[i]=this.contenido.TextoDescripcion.split('|')[i]
                }
               this.visualizarEnVisor=this.contenido.AbrirEnVisor;
               this.textoVinculoArchivo=this.contenido.TextoLink;
               this.contenido.RutaDeArchivo = this.contenido.RutaDelArchivo;
                this.tieneArchivoAdicional=(this.contenido.ArchivoAdicional==null || this.contenido.ArchivoAdicional=='')?false:true;
                this.fechaDatePickerInicio=new Date(this.contenido.FechaDeRegistro+this.zonaHoraria);
               //  this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);
                break;
            case 27:
                this.contenido.ArchivosDeContenidoMicrositios.forEach((element,i) => {
                    element.id = i;
                    this.listaDeArchivos.push(element);
                });
               // this.listaDeArchivos = this.contenido.ArchivosDeContenidoMicrositios;
                this.titulo = this.contenido.TextoDelContenido;
                this.rutaVinculo = this.contenido.RutaDeArchivo;
                  this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);
                break;
            case 22:
                this.visualizarEnVisor=this.contenido.ArchivosDeContenidoMicrositios[0].AbrirEnVisor;
                this.textoVinculoArchivo=this.contenido.ArchivosDeContenidoMicrositios[0].TextoDescripcion;
                this.contenido.RutaDeArchivo = this.contenido.ArchivosDeContenidoMicrositios[0].RutaDelArchivo;
                
                for(var i=0;i<this.contenido.TextoDelContenido.split('|').length;i++){
                this.numeroDeColumnas[i]=this.contenido.TextoDelContenido.split('|')[i]
                }
                  this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);
                  if(this.contenido.ArchivosDeContenidoMicrositios[0].RutaDeArchivoCarpeta != null && !this.contenido.ArchivosDeContenidoMicrositios[0].RutaDeArchivoCarpeta.includes("themisfstest")){             
                    this.vinculo = this.contenido.ArchivosDeContenidoMicrositios[0].RutaDeArchivoCarpeta;
                    this.vinculoArchivoRadio = false;
                    this.descargaArchivoRadio = true;
                                 }
                break;
            case 21:
                this.titulo = this.contenido.TextoDelContenido.split('|')[0];
                this.textoDelContenido=this.contenido.TextoDelContenido.split('|')[1];
                  this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);
                break;
            case 17:
                this.tituloVideo = this.contenido.TextoDelVinculo;
                this.textoDelContenido =this.contenido.TextoDelContenido;
                this.subirVideo = (this.contenido.RutaDeArchivo.includes("youtube") || this.contenido.RutaDeArchivo.includes("youtu.be"))?false:true;
                  if(!this.subirVideo) this.rutaVideo = this.contenido.RutaDeArchivo
                    this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);
                break;

                default:
                     this.fechaDatePickerInicio=new Date(this.contenido.FechaDePublicacion+this.zonaHoraria);
                    break;

            
            }
            

        }

    },
   
    mounted() {
        this.formatoId = this.$store.getters.Get_SICPO_Catalogo_TipoDeFormulario.numeroFormato;
        if(this.formatoId==22 || this.formatoId==26 || this.formatoId==47) this.mostrarUltimaColumna=1;     
        this.acomodaContenidoEnFormulario();
    },
    computed: {
        obtenerTipoDeFormulario() {
             return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_tipoDeFormulario;
        },
        mostrarErrorEnInput() {
            return this.mostrarErroresInput;
        },
        obtenerCambiarFormulario() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormulario;
        },
        obtenerInicializarFormulario() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioDeFormularioInput;
        },
        obtenerCamposRequeridosEnFormulario() {
        return this.$store.getters.Get_SICPO_Catalogo_TipoDeFormulario;
            
        },
        obtenerListadoInicial() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_listaContenidoOriginal;
        },
        modificoOrdenDeContenidos() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioOrdenlistaContenidos;
        },
        obtenerPaginaWebId() {
            return this.$store.getters.Get_SICPO_Catalogos_007PaginasWeb.catalogoPaginaPasoUno;
        },
        obtenerPunterosParaContenido() {
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual;
        },
        obtenerTituloDeSeccion(){
            return this.$store.getters.Get_SICPO_Catalogo_FormatoDeSeccion;
        },


    }
}
</script>
<style  scoped>
.form-inline{
    margin-bottom: 1.5em !important;
}
.caja-campos{
    margin-bottom: 1.5em !important;
    display: block !important;
}
.imagen-actual{
    border-radius:22px;
    border:3px;
    width:80%;
    height:25em;
    margin-left:10%;
    margin-top: 1%; 
    margin-bottom: 1%;
}
.fuente-tabla{
    color:rgb(250, 250, 250);
}

    .container-btn {
        display: flex;                             
        justify-content: space-between; 
    }
    h5, h6{
        user-select: none;
    }
    .btn-group-toggle{
        margin-bottom: 1em;
    }
    .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
        color: white;
        background-color: #57585B;
        border-color: white;
    }
    .btn-secondary {
        color: rgb(106, 108, 112);
        background-color: #323335;
        border-color: rgb(106, 108, 112);
        font-size: 0.95rem;
    }
    .btn-secondary:hover {
        color: white;
        background-color: #323335;
        border-color: white;
    }
    .elementos-archivos-contenido {
         margin-top: 2%;
    }
    .elemento-lista-archivos {
        margin: 0;
    }
    .elemento-eliminar-archivo {
        cursor: pointer;
        margin-left: 4px;
    }
    .linea-vertical {
      width: 0px; /* Use only border style */
      height: 80%;  
      border: 1px inset; /* This is default border style for <hr> tag */
      margin-left: 6px;
    }
    .linea-horizontal {
        margin: 0;
    }
    .opciones-vaciar-listaDeArchivos {
        display: flex; 
        justify-content: flex-start;
    }

    .opcion-ver-listadoArchivos-agregados:hover {
        cursor: pointer;
    }

    .scroll-contenedor {
        height:200px;
        overflow:scroll;
        overflow-x:hidden;
    }

     .contenedor-listado-archivos {
        overflow-y: auto;
        max-height: 200px;
    }

    .contenedor-listado-archivos table {
        border-collapse: collapse;
        width: 100%;
        background-color: #26272b;
        
    }

    .contenedor-listado-archivos th {
        position: sticky;
        top: 0;
        background: #474749;
        border: 1;
    }
    .contenedor-puntero {
        background: #212529;
        border-radius:2px;
        padding: 10px;
        border:1px solid white;
        margin-bottom: 1.5em;
    }

    .contenedor-cambio-seccion {
       display: flex;
       justify-content: space-between;
    }

    .texto-negro {
        color: black;
    }

    .sin-margen-superior {
        margin-top: 0px;
    }



</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/Comun/CFormularioEdicionMicrositio.vue